/*
 * @Author: renjianshu
 * @Date: 2019-01-25 14:11:44
 * @LastEditors: gengming
 * @LastEditTime: 2020-12-03 17:01:30
 * @Description: file content
 */
/*
 * 雨课堂 国际化静态文字
 * @author: chenzhou
 * @update: 2017.12.05
 * @desc 国际化 命名空间格式 page-module-lable
 *
 */

let pages = {
    // 常用语
    common: {
        "lang": "cn", //用来判断当前语言显示
        "ykt": "雨课堂",
        "cancel": "取消",
        "confirm": "确定",
        "finishok": "确认",
        "close":"关闭",
        "publish": "发布",
        "back": "返回",
        "del": "删除",
        "remove": "移除",
        "point": "分",
        "score": "得分",
        "name": "姓名",
        "anonymous": "匿名",
        "unread": "未读",
        "anonymouspoll": "匿名投票",
        "poll": "投票题",
        "option": "选项",
        "multiplem": "多选题",
        "multiples": "单选题",
        "subjective": "主观题",
        "blank": "填空",
        "chooselimit": "最多可选{count}项",
        "locate": "第{index}题",
        "quiz": "试卷",
        "slide": "课件",
        "searchone": "搜索",
        "pull": "下拉刷新",
        "release": "释放更新",
        "loadingText": "正在加载…",
        "Lotuspond": "荷塘雨课堂",
        "cancelselall": "取消全选",
        "continue": "继续",
    },

    // 导航菜单
    nav: {
        "course": "课程",
        "discover": "发现",
        "message": "消息",
        "me": "我",
        "myhomepage": "我的主页",
        "myslides": "我的课件库",
        "mytests": "我的试卷库",
        "mysave": "我的收藏"
    },

    // 课程 教学日志 学习日志
    course: {
        "inclasstip": "当前班级正在上课，进入课堂",
        "courseandclass": "班级课程",
        "openclass": "公开课",
        "addacourse": "我要开课",
        "coursejoinclass": "加入班级",
        "inclass": "正在上课中",
        "coursemanage": "管理",
        "courseinclassstudent": "{count}人",
        "coursemanaged": "我管理的课",
        "coursejoined": "我听的课",
        "coursequitclass": "退出班级",
        "coursequitcfm": "确认退出该班级吗",
        "coursetips": "提示",
        "courseenterclasscode": "输入班级邀请码, 即刻加入班级~",
        "classjoinfailed": "加入班级失败",
        "coursecreate": "课程",
        "coursecreateexample": "如：流体力学",
        "classexample": "如： A班",
        "classcreate": "班级",
        "courseaddclass": "新增班级",
        "coursecreatedone": "完成",

        "createOK":"创建成功",
        "tip_invitestudent":"您可以进入班级邀请学生",
        "youcreateclass":"您创建的班级",
        "enterclass":"进入班级",
        "returncourselist":"返回课程列表",
        "rename":"重命名",
        "classname":"班级名称",
        "save":"保存",
        "dialog_tip":"提示",

        "dellastclass": "课程至少要有一个班级~",
        "courseaddcourse": "新建课程信息",
        "courseeditcourse": "编辑课程信息",
        "coursedelclasswarning": "确认删除该班级吗?",
        "entercoursename": "请输入课程名称",
        "enterclassname": "请输入完整班级名称",
        "coursedelcoursewarning": "确认删除该课程吗",
        "coursedelcoursecfm": "课程删除后，该课程所有班级将被删除",

        "teachinghistory": "教学日志",
        "managestudent": "学生管理",
        "learninghistory": "学习日志",
        "coursemyclassmate": "我的同学",
        "courseinvitestudent": "邀请",
        "coursepermission": "权限",
        "coursemanageagain": "管理",
        "coursequit": "退出",
        "enterclass": "进入课堂",

        "coursepublishslides": "发布课件",
        "coursepublishquiz": "发布试卷",
        "courseannounce": "发送公告",
        "courseno学习日志": "还没有学习日志",
        "coursepublishintro": "点击+号尝试将课件、试卷或公告发布到班级吧",
        "courseteachercheckall": "老师发布的课件、课堂教学、试卷等教学活动都会记录在这里",
        "scheduledeliver": "预约",
        "scheduledeliverpublish": "你有{length}个预约发布",
        "coursefold": "收起",
        "courseunfold": "展开",
        "courseslides": "课件",
        "coursequiz": "试卷",
        "courseedittitle": "编辑标题",
        "coursedel": "删除",
        "courseinclass": "课堂",
        "courseannounce2": "公告",
        "coursexperiment": "实验",
        "coursenostudentpush": "您还没有邀请学生",
        "courserightnow": "立即去",
        "courseinvite": "邀请",
        "coursesearch": "搜索",
        "courseteacher": "授课教师",
        "coursecoteacher": "协同教师",
        "exitcourse": "退出班级",
        "coursestudent": "学生",
        "coursenotbound": "未绑定",
        "coursegueststudent": "旁听生",

        "coteachernoedit": "协同教师无法编辑标题",
        "coteachernodel": "协同教师无法删除此教学活动",
        "courseaddtitle": "输入新的标题~",
        "coursedelpubish": "确认删除这次发布吗?",
        "courseactivitydel": "确认删除这次教学活动吗?",
        "coursedelcfm": "确认删除该学生吗?",
        "coursebecomecfm": "确认转正为正式学生吗？",

        "coursedelstudentfailed": "删除学生失败",
        "courseexitcfm": "确认退出班级吗?",
        "coursefailtoexit": "退出该班级失败",

        "coursesun": "周日",
        "coursemon": "周一",
        "coursetue": "周二",
        "coursewed": "周三",
        "coursethu": "周四",
        "coursefri": "周五",
        "coursesat": "周六",
        // "": "周{number}",
        "appointmentmins": "约{minute}分钟后发布",
        "appointmenthours": "约{hour}小时后发布",
        "appointmentdays": "约{days}天后发布",
        "appointmentfailed": "发送失败",

        // 学生管理
        "coteacherinclass": "本班协同教师",
        "addcoteacher": "添加协同教师",
        "setpermission": "设置权限",
        "deletepermissioncfm": "确认移除该协同教师吗？",
        "deletepermissionfailed": "删除该老师权限失败",
        "selectall": "全选",
        "selectnone": "不选",
        "confirmdelete": "删除",
        "confirmdelete1": "移除",
        "managetips": "此课程选课信息由教务系统直接导入雨课堂中,只可对旁听生进行管理",
        "managetipshasadmin": "此课程已经开放教师管理班级成员，可以对学生和旁听生进行管理",
        "auditorbecomes": "旁听生转正",
        "managestudents": "学生管理",
        "becomesregular": "转正",
        "clear": "清空",
        "noaddtests": "您还没有添加任何试卷喔",
        "coursechooseslide": "选择课件(单选)",
        "coursedelstudent": "确认删除所选学生吗",
        "deleteOK": "删除成功",
        "saveOK": "保存成功",

        // 新增
        "invitestudent": "邀请学生加入",
        "ArchivedClasses": "已归档班级",
        "no_guest_student_tip": "当前无旁听生",
        "pullrefresh": "上拉刷新",
        "toprelease": "释放更新",
        "toploading": "加载中...",
        "nonetwork": "网络不给力~",
        "loadmore": "加载更多",
        "sending": '发送中',

        "new_onlessontip": "你有{length}个课正在上课",
        "new_teach": "教",
        "new_listen": "听",
        "new_myteach": "我教的课",
        "new_mylisten": "我听的课",
        "onlessonbar": "你有 {count} 个班级正在上课",
        "onlessonbar2": "有 {count} 个班级正在上课",
        "semicolon": "；",
        "weekexam": "最近一周有 {count} 门考试",

        // 新增课程设置完善需求
        "allname": "全称",
        "activeclass": "活跃班级",
        "addclass": "添加班级",
        "alias": "简称",
        "addalias": "添加简称",
        "noclass": "暂无活跃班级",
        "gotoset": "自动跳转到课程设置页",
        "deleteclasstip": "删除班级后，班级中所有的教学数据将一同被删除",
        "deleteclasstip2": "删除班级后，班级中所有学生将被移出此班级",
        "studenttotal": "学生总人数",
        "activitytotal": "教学活动总计",
        "classalias": "班级简称",
        "entername": "请输入名称",
        "setclassalias": "设置班级简称",
        "archiveclasses": "归档班级",
        "deleteclass": "删除班级",
        "removearchive": "移出归档",
        "coteachernopermission": "协同教师不可操作此项",
        "pronopermission_rename": "该班级由教务系统导入，班级名称不能修改",
        "pronopermission_del": "该班级由教务系统导入，只能从教务端删除",
        "archiveconfirm": "确定要归档该班级吗？",
        "removearchiveconfirm": "确定要将该班级移出归档吗？",
        "deleteclassconfirm": "确定删除此班级？",
        "delfail": "删除失败，请重试",
        "coursename": "课程名称",
        "courseshortname": "课程简称",
        "delcourse": "删除本课程",
        "deletecoursetip": "删除课程后，该课程下的所有班级和教学数据都将被删除且不可恢复",
        "coursetotal": "课程下共有班级",
        "gotolist": "自动跳转到课程列表",
        "delcourseconfirm": "确定删除课程？",
        "classaliasmaxlength": "班级简称 (最多16个字)",
        "classnamemaxlength": "班级名称 (最多28个字)",
        "courseshortnamemaxlength": "课程简称 (最多16个字)",
        "coursenamemaxlength": "课程名称 (最多28个字)",
        "classshortnametip": "若您设置了班级简称，显示班级名称时会优先取简称。",
        "courseshortnametip": "若您设置了课程简称，显示课程名称时会优先取简称。",
        "protips": "本课程由教务系统导入，班级和选课数据定期从教务系统同步",
        "cannotrenamecourse": "该课程由教务系统导入，课程名称不能修改",
        "cannotchangecoursetype": "该课程由教务系统导入，课程类型不能修改",
        "proclasstips": "本班级由教务系统导入，班级信息和选课数据定期从教务系统同步",
        "cannotchangeterm": "学期信息由教务端设置，教师端不能修改",
        "setcoursetype": "请先前往课程管理页，设置课程类型",

        // 完善信息检查入口
        'gocomplete': '去完善',
        'completetitle': '请完善个人信息',
        'completemsg': '根据国家政策要求，该操作需要实名认证。为保障您的账户安全及正常使用，请完善个人信息。',
        "gobind": "去绑定",
        "authrealname": "请绑定手机号",
        "bindphonetips": "根据国家政策要求, 该操作需要实名认证, 为保障您的账户安全及正常使用, 请完成手机号绑定。",
    },

    // 试卷 主观题等
    quiz: {
        "showqusetion": "显示题目",
        "quizlocate": "第{index}题",
        "quizpoint": "{score}分",
        "datishic": "答题时长：",

        "quiztext": "文本",
        "quizpic": "图片",
        "quizvoice": "音频",
        "quizadd": "添加",
        "quizvoicelimit": "音频仅支持9条",
        "quizback": "返回题目",
        "quizpreview": "提交预览",
        "quizcorrect": "答案",
        "quizkeepedit": "继续编辑",
        "quizsubmit": "提交答案",
        "quizsave": "保存答案",

        "quiztotalscore": "总分",
        "quizfullmarks": "满分",
        "quiznogradesubjective": "主观题未批阅",
        "quizgradingsubjective": "主观题批改中",
        "quizcheckobjective": "客观题",
        "quizcheckscore": "得分",
        "quizchecksubjective": "主观题",
        "quiznotgraded": "未批阅",
        "curquiznotgraded": "本题未批阅",
        "seeannotation": "点击查看批注",

        // 主观题作答
        "timeupnoanswer": "已经过期，不能答题",
        "quizanswer": "作答",
        "scoreofthispro": "本题得分",
        "quizteachercomment": "教师评语",
        "quizanswerkey": "答案解析",
        "recording": "录音中 (最长60s)",
        "holdtotalk": "按住说话",
        "releasetosend": "松开完成",
        "confirmanswer": "请确认答案",
        "quizsubmitok": "提交成功",
        "delpiccfm": "确定删除图片？",
        "delallpiccfm": "确定删除所有图片？",
        "deltextcfm": "确定删除文本",
        "delaudiocfm": "确定删除语音？",
        "delallaudiocfm": "确定删除所有语音？",
        "quiznetworkerror": "当前网络不畅，请检查系统",
        "imgIllegal": "图片可能存在违规，请检查后重试",
        "quizpiclimit": "图片不能超过九张",
        "reuploadpiconly": "当前仅支持图片格式，请重新上传",
        "imagesizelimit": "图片不可超过10M，请重试",
        "accessrecord": "添加语音答案，需允许雨课堂使用录音功能",
        "takedifficult": "上传有问题？点击这里",

        //主观题上传附件
        "upload_tip_mobil":"提示：使用网页版可以上传附件噢！",
        "attachment_file":"附件",
        "add_attachment_file":"添加附件",
        "upload_tip0":"提示：附件允许上传1个，大小100M以内",
        "upload_tip_quiz":"提示：附件允许上传1个，大小300M以内",
        "upload_tip1":"查看可上传的格式",
        "upload_tip2":"可以上传的文件类型包括：",
        "file_uploading":"附件上传中...",
        "file_upload_fail":"附件上传失败",
        "file_upload_complete":"上传成功",
        "file_max_limit":"文件大小超过限制",
        "file_format_limit":"文件格式不符合要求",
        "downloadfile_tip":"请使用雨课堂网页版下载附件",

        //new
        "confirm_deletefile":"确定删除附件？",

        // 主观题批改页
        "graded": "已批改",
        "isgrading": "批改中",
        "quiznoanswer": "该学生没有作答题目",
        "quiztotalpoint": "本题共{sourceScore}分",
        "quizentercomment": "请输入评语",
        "good": "写得不错",
        "comeon": "继续加油",
        "uniqueidea": "想法很独特",
        "excellent": "小红花",
        "required": "必填",
        "quizprevious": "上一位",
        "quiznextpro": "下一题",
        "quiznext": "下一位",
        "quizedit": "修改",
        "quizcommentsaved": "当前分数和评语将被自动保存",
        "quizaudio": "录音不能超过九条",
        "quizsubmitting": "提交中",
        "quizshowquestion": "显示题目",
        "quizgradeinvite": "请您打分",
        "notgraded": "老师还未打分",

        // 试卷反馈
        "finisheddetails": "完成详情",
        "gradingdetails": "批改详情",
        "submission": "交卷时间",
        "gradingtime": "批复时间",
        "noonefinished": "还没有学生完成",
        "testfinisheddetails": "试卷完成情况",
        "finisheddetails": "完成情况",
        "checktestpaper": "查看试卷",
        "graded": "已批改",
        "finishedtest": "完成试卷",
        "totalstudentone": "班级人数",
        "viewdetails": "查看详情",
        "scoredistribution": "总分分布",
        "allvote": "此试卷全部为投票题",
        "ungradedsubjectiveproexist": "您还有主观题尚未批改",
        "clickbarcharttograde": "点击下面主观题柱状图进行批改",
        "noonefinishedtest": "还没有学生完成试卷",
        "answerdetails": "答题情况",
        "deletepulishcfm": "是否删除本次发布",
        "deletepublishfailed": "删除发布失败",
        // "standardopt": "本题正确选项为",
        "noanswerforpoll": "本题为投票，没有正确答案",

        // 客观题作答详情
        "anonymouspollnodetail": "本题为匿名投票，不显示投票人",
        "numberofvotes": "{count}票",
        "standardopt": "本题正确选项为: ",
        "numberofstudents": "{count}人",
        "noanswers": "还没有学生作答",

        "loadingdata": "正在加载数据...",
        "answered": "已作答",
        "notansweredone": "未答题",

        "gradeone": "打分",
        "": "条",
        "loadmore": "加载更多",
        "okone": "确定",
        "thisquestion": "本题",
        "cancel": "取消",
        "positivescore": "分数必须为正数",
        "exceedmaximumscore": "分数超过最大本题分值，请重新输入",
        "keepadecimal": "分数最多保留一位小数，请重新输入",
        "numberonlywarning": "所输分数必须为数字，请重新输入",
        "unclearstudents": "不懂人数",
        "noquestiontoanswer": "本堂课没有习题",
        "nounclearslides": "没有被点击『不懂』的课件",
        "quantityone": "红包个数：",
        "standardopt": "本题正确选项为:",
        "noanswerforpoll": "本题为投票，没有正确答案",
        "gradingtime": "批复时间",
        "timelimitedtest": "本套试卷限时",
        "min": "分钟",
        "deadline": "截止日期",
        "testdeadline": "本套试卷截止时间",
        "timelimitedtest": "本套试卷限时",
        "checkhw": "查看作业",
        "finishedhw": "已完成作业",
        "hwfinisheddetail": "作业完成情况",
        "finishedhwstudent": "n位同学完成作业",
        "gradedhwnumber": "份作业已经批复",
        "scorereport": "得分情况",
        "questionlocate": "第2题",
        "accuracyone": "正确答题率",
        "editpublishtitle": "编辑本次发布标题",
        "deletepublish": "删除本次发布",
        "deletepublishone": "确认删除本次发布吗?",
        "deletepublishfailed": "删除发布失败",

        // 分组作答主观题
        "groupanswer": "本题为小组作答",
        "temporarygroup": "临时组",
        "submittips": "每个小组仅一次提交答案的机会，提交后答案和答题成员都不可修改，请组员间充分沟通后再提交",
        "check": "返回检查",
        "temporaryconfirm": "确定以临时组(仅你自己)提交答案？",
        "notingroup": "未进组",
        "contactteacher": "联系老师将你加入其他小组或以临时组(仅你自己)提交答案",
        "iknow": "我知道了",
        "submitted": "在你加入前小组已交过答案",
        "submitfail": "提交失败",
        "onceTip": "重要提示",

        "gradetips": "* 请前往网页版{host}批改主观题",
        "entertext": "输入答案",
        'clicksave':'答完请点保存，避免自动保存不及时',
        Return: '发回修改',
        Returned: '已发回修改',
    },

    // 课前预习 预习反馈 完成情况等
    cards: {
        'sensitive_words':'输入内容含敏感词，请检查后重试',
        "dyzgtwpgs": "当有主观题未批改时，此排名可能不是最终排名",
        "dfygdd": "得分由高到低",
        "dfyddg": "得分由低到高",
        "qdsjpx": "签到时间排序",
        "wszxh": "未设置学号",
        "donealready": "已完成",
        "checkedpreview": "已查看",
        "nocheckedpreview": "未查看",
        "noonefinishpreview": "还没有学生完成学习",
        "noonepreviewing": "还没有学生正在进行",
        "allfinish": "全部学生已开始学习",
        "previewdetail": "完成情况",
        "finisheddetails": "完成情况",
        "finishedpreview": "已完成",
        "checkslides": "查看课件",
        "viewdetails": "查看详情",
        "studentscheckedslides": "已查看",
        "totalclassstudents": "总人数",
        "answerdetails": "答题情况",
        "subjectivepro": "主观题",
        "gradingrate": "批改率",
        "answerrate": "答题率",
        "averagescore": "平均分",
        // "poll": "投票题",
        "grading": "批改",
        "webgradetips": "温馨提示：网页版（{url}）批改主观题更便捷",
        "accuracy": "正确率",
        "objectivequestion": "客观题",
        "answerrate": "答题率",
        "teacherdatacheck": "查看",
        "studentfeedback": "学生反馈",
        // "anonymous": "匿名",
        // "unread": "未读",
        "nostudentfeedback": "目前还没有学生反馈信息",
        "detaileddata": "详细数据",
        "webdownloadexcel": "下载多次Excel数据 请登录网页版 {url}",
        "teachingdesign": "教学设计与备忘",
        "teachingdesigntip": "您可以在这里可以记录教学设计和心得等笔记，内容仅自己可见",
        "teachingdesigntip2": "您可以在这里可以记录学习内容和心得等笔记，内容仅自己可见。",
        "editpublishtitle": "编辑发布标题",
        "deletepublish": "删除本次发布",
        "editpublishset": "编辑发布设置",
        "loadmore": "加载更多",
        "mailreceivedata": "本次详细数据将会发送至以下邮箱",
        "enterfrequentmail": "请你输入常用邮箱",
        "mailformaterror": "邮件格式错误",
        "datasentok": "数据已发送",
        "yktwebtips": "温馨提示：在雨课堂网页版 {url}",
        "deleteexcelnow": "可直接下载多次详细数据的Excel文件哦～",
        "enternewtitle": "输入新的标题~",
        "deletepulishcfm": "是否删除本次发布",
        "deletepublishfailed": "删除发布失败",
        "previewdetails": "学习详情",
        "previewtips": "随机-规则组卷暂不支持查看",

        // 学生预习课件
        "previewviewslides": "查看课件",
        "previewduration": "观看时长：",
        "previewscore": "习题得分：",
        "finishstudy": "完成学习：",
        "finishproblem": "完成习题：",
        "wgky": "未观看页：",
        "answerdetails": "答题情况",
        "previewungraded": "未批",
        "previewnoquestion": "本次课件中没有习题。",
        "previewreporttoteacher": "报告老师",
        "anonymous": "匿名",
        "unread": "未读",
        "reporttoteachertip": "有什么问题可以直接报告给老师哦",
        "learningthoughts": "学习心得",
        "teachingdesigntip": "您可以在这里可以记录教学设计和心得等笔记，内容仅自己可见",
        "previewhours": "{hour}小时",
        "previewmins": "{minuts}分钟",
        "previewsecs": "{seconds}秒",
        "previewfeedbacktip": "输入意见，反馈给老师",
        "anonymoussend": "匿名发送",
        "previewcfm": "确认发送",
        "previewsending": "正在发送...",
        "previewentertip": "请输入内容",
        "sentok": "发送成功",
        "sendfailed": "发送失败！",
        "progress": "进度：{depth}/{count}页",
        "completionprogress": "{depth}/{count}页",

        // 不懂收藏
        "unknownpagecount": '点不懂页数',
        "unknowntotalpage": '课件总页数',
        "allslides": "全部",
        "problemslides": "习题",
        "unknownslides": "不懂",
        "viewresult": "查看结果",
        "slidesaudio": "语音",
        "favorite": "收藏",
        "slidescomment": "评论",
        "viewall": "查看全部",

        "sendbtn": "发送",
        "commentfail": "评论失败，请重新发送",
        "commenting": "评论中",
        "commentok": "评论成功",

        // 小程序中网络视频提示
        "xcxzwfbfwlsp": "小程序中无法播放网络视频",
        "qnzgzhgk": "请您在雨课堂公众号中观看",
        "rhcz": "如何操作",
        "miniprogramlinktip": "小程序中无法打开外部链接，请您在雨课堂公众号中查看",
        "studentId": "按学号排序",
        "progressinstruction": "学习进度说明：",
        "graphicpages": "1.图文页",
        "watching3stocomplete": "指课件页仅包含图片和文字，观看1s以上算完成学习",
        "viewingmorethan1stocomplete": "当课件页仅包含背景图及20个以内的文字时，观看1s以上即算完成",
        "problempages": "2.习题页",
        "needtocompleteexercisestocomplete": "指课件页包含习题，需完成习题作答算完成学习",
        "videopage": "3.视频页",
        "watchthevideotocomplete": "指课件页包含视频，需观看视频90%以上算完成学习，有多个视频时需全部观看90%以上；拖拽视频则不计入观看时长",
        "specialinstructions": "4.特殊说明",
        "specialinstructionsdesc": "当课件页包含习题和其他类别时，课件页完成情况以习题完成情况为准；<br/>当课件页包含视频和图文时，课件页完成情况以视频完成情况为准",
        "inputPassword": "请输入试卷密码",
        "inputPassword2": "请输入四位密码",
        "password": "密码",
        "passwordIncorrect": "密码格式不正确",
    },

    // 我的模块 主页 钱包 收藏 我的试卷 课件
    my: {
        "bonusexpenditure": "红包支出",
        "withdraw": "提现",
        "topup": "充值",
        "bonusincome": "红包收入",
        "bonusrefund": "红包退款",
        "wallet": "钱包",
        "bonus": "红包",

        "myyktwallet": "我的钱包",
        "myslides": " 我的课件库",
        "mytests": "我的试卷库",
        "mysave": "我的收藏",
        "schoolbinding": "身份绑定",
        "evaluation": "评教",
        "reciveQuestionnaire": "我收到的问卷",
        "questionnairefeedback": "评价我的问卷",
        "editpersonalinfo": "编辑个人信息",
        "saveinfo": "保存",
        "name": "姓名",
        "nameeg": "请输入姓名",
        "gender": "性别",
        "gendermale": "男",
        "genderfemale": "女",
        "birthofdate": "出生日期",
        "role": "身份",
        "pleaseselect": "请选择",
        "student": "学生",
        "teacher": "老师",
        "otherrole": "其他人员",
        "school": "院校",
        "schooleg": "请输入学校",
        "department": "学院",
        "departmenteg": "请输入学院",
        "company": "单位",
        "companyeg": "如：清华大学",
        "studentid": "学号",
        "studentidnote": "学生身份请输入学号",
        "email": "邮箱",
        "frequentemailnote": "请填写常用邮箱",
        "finishok": "确认",
        "myhomepage": "我的主页",
        "changesaved": "本次修改已保存",
        "uploadingimage": "正在上传图片...",
        "networkerror": "当前网络不畅，请检查系统",
        "imageonly": "当前仅支持图片格式，请重新上传",
        "imagesizelimit": "图片不可超过10M，请重试",
        "profile": "个人信息",
        "select": "选取",
        "cancel": "取消",
        "typeprofile": "填写信息",
        "leavetrace": "花30秒留下足迹",
        "askforfeedback": "以便为您提供更好的功能服务",
        "entername": "请输入姓名",
        "enterschool": "请输入学校",
        "enterstudentid": "学生身份请输入学号",
        "submitfailed": "提交个人信息失败",
        "connectionfailed": "网络连接错误，请稍后重试。",

        "bill": "账单",
        "mybalance": "我的余额",
        "topup": "充值",
        "withdraw": "提现",
        "withdrawnotice": "提现须知",
        "questionwithdraw": "问题1 钱包的余额如何提现？",
        "answerwithdraw": "在『我的钱包』中点击『提现』，余额超过2元方可发起提现申请。提交成功后，金额将于三个工作日内进入您的微信零钱。",
        "questioncharge": "问题2 为什么提现需要收取2%的手续费？",
        "answercharge": "这是微信转账在过程中收取的手续费，雨课堂不会从中获利。",
        "questionwithdrawlimit": "问题3 提现是否有上限？",
        "answerwithdrawlimit": "由于微信的限制，每位用户单日最高可提现金额为2000元。",
        "mywallet": "我的钱包",
        "nobillfound": "还没有任何账单信息",
        "thismonth": "本月",
        // 钱包新增
        "banktip": "温馨提示：老师可以使用钱包的钱发送课堂红包",
        "bankhowbonus": "如何发送课堂红包？",
        "bankquestionwithdraw": "钱包的余额如何提现？",
        "bankanswerwithdraw": "在『我的钱包』中点击『提现』，余额超过2元方可发起提现申请。提交成功后，金额将于三个工作日内进入您的微信零钱。",
        "bankquestioncharge": "为什么提现需要收取2%的手续费？",
        "bankanswercharge": "这是微信转账在过程中收取的手续费，雨课堂不会从中获利。",
        "bankquestionwithdrawlimit": "提现是否有上限？",
        "bankanswerwithdrawlimit": "由于微信的限制，每位用户单日最高可提现金额为2000元。",
        "bankclose": "关闭",

        "today": "今天",
        "choosetopupamount": "请选择您要充值的金额",
        "moreamountchoice": "其他",
        "entertopupamount": "请输入您要充值的金额",
        "back": "返回",
        "confirmtopup": "确认充值",
        "tipsinwallet": "温馨提示",
        "yktbalanceuse": "钱包里的余额可用于课堂中发红包或购买公开课程",
        "enterwithdrawamount": "请输入您要提现的金额",
        "currentbalance": "当前余额： {balance}元",
        "confirmwithdraw": "确认提现",
        "withdrawrules": "提现须知",
        "withdrawtips": "温馨提示：将扣除提现金额的2%作为手续费",
        "rechargetips": "充值金额单次最高限额为10000元，请核实金额",
        "transfertimetips": "零钱将在3个工作日内到达您的微信账户。",
        "failtowithdraw": "抱歉，单日提现上限为2000元，您已超支。",
        "decimalwarning": "抱歉，资金不能为小数",
        "withdrawmin": "单笔提现金额至少为2元",
        "insufficentbalance": "抱歉，您的钱包余额不足。",
        "balanceerror": "账户余额异常",
        "systemerror": "系统发生了错误",

        "morningsaves": "你还没有任何收藏",
        "morningwords": "早起时刻-单词部落",
        "morningpoem": "早起时刻-诗词小栈",
        "morningbooks": "早起时刻-书影时光",
        "anonymous": "匿名",
        "answer": "回答",
        "mysave": "我的收藏",
        "addtag": "添加标签",
        "myslides": "我的课件库",
        "chosennumber": "已选 {chosenNumber} 个",
        "selectall": "全选",
        "confirmdelete": "确认删除",
        "choosemoreslide": "请至少选择一个课件",
        "deleteslidescfm": "确认删除所选课件吗?",
        "plugintips": "提示",
        "manage": "管理",
        "delete": "删除",
        "noslidesfound": "你还没有任何课件",
        "pluginykt": "去试试雨课堂桌面端插件吧",
        "mytests": "我的试卷库",
        "notest": "你还没有任何试卷",
        "deletetestcfm": "确认删除该试卷吗?",
        "medeletetestfailed": "删除试卷失败",

        //后补充
        "medelslidescfm": "确认删除该课件吗？",
        "medelslidesfailed": "删除课件失败",
        "tips": "提示",
        "chooseonemoretest": "请至少选择一个试卷",
        "medelquiz": "确认删除所选试卷吗?",
        "mewallettopup": "钱包充值",
        "mewithdraw": "钱包提现",
        "withdrawmorethantwo": "提现金额最低为2元，请核实金额",
        "receivedanddeducted": "到账金额￥{getMoney}元，扣除手续费￥{fee}元",
        "ykttopup": "雨课堂-钱包充值",
        "mebill": "我的账单",
        "meupdatingprofilepic": '正在更新头像...',
        "merealname": '真实姓名',
        "meschoolbelongs": '所属学校',
        "merole": '社会身份',
        "meteacher": '教师',
        "meothers": '其他',
        "mestudentid": '在校学号',
        "schoolstudent": '在校学生',
        "schoolteacher": '在校老师',
        "universitybelongs": '所属院校',
        "userunbind": '解绑账号',
        "addschool": '增加学校',
        //设置语言新增
        "setting": '设置',
        "selectlang": '多语言',
        "savelang": '保存设置',
        "savinglang": '正在设置语言...',
        "savesuccess": '设置成功',

        // 个人信息完善
        'infocosttime': '花30秒完善你的信息',
        'infogood': '方便老师快速认识你',
        'infogoodteacher': '方便学生了解授课教师',
        'infoorg': '组织/机构',
        'infoorgtip': '可以为空',
        'infonumbereg': '学生身份请输入学号',
        'infotip': '* 你可以在“我的主页”中随时修改个人信息',
        'backtomini': '信息已修改成功，返回后下拉刷新即可',
        'backtominiok': '我知道了',

        // 支付提示
        'payfailtip': '小程序中暂不支持充值，请前往雨课堂公众号操作~',
        "storeboards": "板书收藏（共{total}页）",
        // 学校绑定列表
        'moreSchool': '更多学校添加中…',

        // 通用账号密码设置
        'accountsetting': "账号及绑定设置",
        'gosetting': '去设置',
        'languagelabel': '语言',
        'language': '中文',
        'subscribe_manage': '订阅通知管理',
        'hasbeenset': '已设置',
        'wechat': '微信',
        'phone': '手机号',
        'gobind': '去绑定',
        'email': '邮箱',
        'password': '登录密码',
        'settips': '* 绑定手机号/邮箱并设置登录密码，可以使⽤账号+密码的⽅式登录⾬课堂和学堂在线网站',
        'settips_thu': '* 绑定手机号/邮箱并设置登录密码，可以使⽤账号+密码的⽅式登录荷塘雨课堂',
        'settips_changjiang': '* 绑定手机号/邮箱并设置登录密码，可以使⽤账号+密码的⽅式登录长江雨课堂',
        'settips_huanghe': '* 绑定手机号/邮箱并设置登录密码，可以使⽤账号+密码的⽅式登录黄河雨课堂',
        'bindemail': '绑定登录邮箱',
        'emailplaceholder': "请输入邮箱地址",
        'verifyplaceholder': '请输入验证码',
        'getcode': '获取验证码',
        'bind': '绑定',
        'verifycodeerror': '验证码错误',
        'emailerror': "请输入正确的邮箱",
        'bindsuccess': "绑定成功",
        'hasbound': '该邮箱已经绑定过雨课堂ID',
        'youhavebound': '您已经绑定邮箱',
        'replaceemail': '更换邮箱',
        'setpassword': '设置密码',
        'reenter': '确认密码',
        'confirm': '确定',
        'changepassword': '修改登录密码',
        'oldpassword': '原密码',
        'newpassword': '新密码',
        'enter': '请输入',
        'oldpassworderror': '原密码错误',
        'newpassworderror': '新密码两次输入不一致',
        'setsuccess': '设置密码成功',
        'lengthlimit': '8-16位，同时包含小写字母、大写字母和数字。',
        'phoneerror': '请输入正确的手机号',
        "bindPhone": "绑定手机",
        "bound": "您已经绑定手机号",
        "replacePhone": "更换手机",
        "bindPhone2": "绑定手机号",
        "verifiplaceholder": "请输入验证码",
        "getVerificationCode": "获取验证码",
        "bind": "绑定",
        "regain": "重新获取",
        "lawtips": "根据法律要求，互联网账号需实名认证，为保障您的账户安全及正常使用，请完成手机号绑定。",
        "second": "秒",
        "receivecode": "收不到验证码",
        "extractminiprogram": "长按识别小程序码绑定手机",
        "closewindow": "绑定完成后，请关闭此窗口",
        "pleasebindfirst": "请先绑定",
        "wrongemail": "错误的邮箱格式",
        "wrongphone": "错误的手机号格式",
        "emailhasbond": "邮箱已被绑定",
        "codeexpired": "验证码已过期",
        "wrongcode": "错误的验证码",
        "wrongoldpassword": "错误的旧密码",
        "invalidnewpassword": "无效的新密码",
        "codefailedtobesent": "短信验证码发送失败",
        "forgetpassword": "忘记密码？",
        "resetpassword": "重设密码",
        "verifyphonenumber": "验证手机号",
        "besenttotheboundphonenumber": "验证码将发送至绑定的手机号",
        "pleasebindyourphonefirst": "请先绑定手机",
        "notblankspaces": "密码中不能包含空格",
        "ruleerror": "密码格式错误",
        "notchinese": "密码不能包括中文字符",
        "minlength8": "密码长度不能小于8个字符",
        "errornewpassword": "密码不符合要求，请重新输入",
        "bindthirdaccount": "绑定的第三方账号",
        "txmeet": "腾讯会议",
        "gotobind": "去绑定",
        "changebindtitle": "该手机号已绑定其他{env}账号，如果继续操作，原账号将自动解绑。是否继续？",
        "changebinddesc": "注：换绑后原账号将不能使用该手机号登录，如果其未绑定微信、邮箱等登录方式，将无法访问原账号数据。",
        "smscodeerr": "短信验证码错误",
        "samephone": "该手机号与当前已绑定的手机号相同",
        "xuetangoryktsamephone": "该手机号已绑定其他雨课堂或学堂在线账号",
        "checkcourselist": "查看{count}门课程 ",
        "accountnocourse": "该账号下无选课记录，建议换绑手机号到新账号。",
        "originaccountjiebang": "换绑后原账号（ID{id}）将会自动解绑，如果其未绑定微信、邮箱等登录方式，原账号将无法登录。是否继续？",
        "mergeaccount": "建议合并数据到该账号（ID{oid}）。合并后，当前账号（ID{nid}）将被弃用，您所有的选课及学习数据都会被保留。",
        "continuenext": "继续，我要",
        "merge": "合并",
        "changebind": "换绑",
        "coursecount": "该账号（ID{id}）下共{count}个教学班",
        "ykt": "雨课堂平台",
        "teach": "我教的课",
        "learn": "我听的课",
        "xuetangx": "学堂在线平台",
        "mergeerror": "原绑定账号已关联有微信相关信息，无法合并。请更换手机号重新绑定。",
        "bindemailtologin": "建议为ID{id}绑定邮箱，以用于登录查看数据。",
        "notbindemail": "不绑定邮箱，自愿弃用ID{id}",
    },

    // 预约发布 试卷发布
    publish: {
        "scheduledeliverfailedone": "预约发送失败，请重新发送",
        "publishname": "发布名称",
        "quizone": "试卷",
        "timetopublish": "发布时间",
        "deadlineone": "完成截止时间",
        "quizdurationone": "考试时长（分钟）",
        "quizdurationone2": "考试时长",
        "releasetimeone": "公布答案时间",
        "publishclassone": "发布班级",
        "totalclassesone": "共 {length} 个班",
        "deletepublishone": "删除本次发布",
        "cancelone": "取消",
        "okone": "确定",
        "delete": "删除",
        "confirmone": "确认",
        "publishinstruction": '发布{name}帮助说明',

        "setdeadlinetips": "若设定完成截止时间，到期后学生将不能答题，完成后数据也不再更新，但在课件查看截止时间内仍能查看课件；",
        "nosetdeadlinetips": "若不设定完成截止时间，学生在课件查看截止时间内随时可以查看课件并答题，完成后数据将实时更新；",
        "systemsubmitanswers": "设定截止时间后，到期学生将仍能看到试卷，但无法继续作答或提交试卷，试卷完成数据及得分分布也不再更新。到截止时间时，系统将自动提交学生所作答的全部内容。",
        "timernostop": " 学生必须在规定的时间长度内提交试卷。点击作答开始计时，若中途退出，计时不停止。到时后系统将自动提交学生所作答的全部内容。",
        "releasetips": "正确答案将在到达此时间时向学生公布，在此之前，学生即使提交试卷也无法知晓正确答案及相关答案解析。",
        "releasetips_col": "正确答案将在到达此时间时向学生公布，在此之前，学生即使提交后也无法知晓正确答案及相关答案解析。",
        "close": "关闭",
        "publish": "发布",
        "publish1": "发布",
        "none": "无",
        "publishnow": "立即发布",
        "nowtime": "当前时间",
        "": '["日","一","二","三","四","五","六"]',
        "notimelimitone": "不限时",
        "showaftersubmission": "交卷后立即显示",
        "showaftersubmission_col": "提交后立即显示",
        "nochooseclass": "您还未选择发布的班级",
        "publishtimenoearliernow": "发布时间不能早于当前时间",
        "ddltimenoearliernow": "截止时间不能早于当前时间",
        "ddltimetip": "当前截止时间过早，不满足考试时长",
        "testdurationzero": "考试时长不能为0",
        "noearlierthanpublishtime": "截止时间应在发布时间之后\r\n请重新设置",
        "changecfmone": "是否确认修改发布信息",
        "publishcfmone": "确认发布到班级",
        "deletecfmone": "是否确认删除本次预约",
        "hour": "小时",
        "min": "分钟",
        "min1": "分",
        "hour2": "点",
        "selecttime": "选择时间",
        "today": "今天",
        "tommrrow": "明天",
        "thedayaftertommorrow": "后天",
        "monthdayweek": "月 日 周",

        "hasbeensent": "已发送",
        "classes": "个班级",
        "failSendClasses": "个班级",
        "sendLoading": '发送中...',
        "sendWaitTip": "当前发送的课件较多时，排队等候需要较长的时间",
        "sendWaitPlease": "关闭本页面，不影响您的发送<br/>发送成功后，我们会给您的微信发送通知</br>请您不要重复操作，避免拥堵",

        // 课下主观题分组作答
        "answerway": "作答方式",
        "totalgroup": "共{count}组",
        "changegroup": "换组",
        "nogroup": "暂无分组",
        "archivetips": "有班级已归档，需要发布课件请先将其移出归档",
        "answerwaydesc": "当课件中含有主观题，且目标班级拥有至少一个分组时，可选择分组作答。该课件中的全部主观题，都将按照所选分组进行作答。",
        "hassubject": "课件中仅全部主观题支持小组作答",
        "nosubject": "课件中不含有主观题不支持小组作答",
        "answerway_person": "个人作答",
        "nogrouptips": "当前班级暂无分组，请先分组或选择个人作答",
        "choosegroup": "选择分组",
        "maximum": "最多只能选择5个班级",
        "coursewarecheckauth": "课件查看截止时间",
        "endnolimit": "完成后不可见",
        "setimelimit": "设定时间后不可见",
        "coursewarechecktime": "课件查看截止时间",
        "checklimitneed": "请选择可查看时间",
        "checklimitnow": "课件查看截止时间不能早于当前时间",
        "checklimitpub": "可查看时间不能早于发布时间",
        "checklimitdeadline": "课件查看截止时间不能早于完成截止时间",
        "curpptnotcheck": "该课件当前已不可查看",
        "curpptnotcheckbr": "该课件当前<br/>已不可查看",
        "exercisenocheck": "习题当前已不可查看",
        "curexercisenocheck": "该习题当前已不可查看",
        "answertimedeadline": "公布答案时间需 >= 截止时间",
        "setpptchecktips": "若设定课件查看截止时间，到期后学生将不能查看课件；",
        "changepptchecktips": "更改课件查看截止时间后，对全部学生生效。",
        "limited": "受限",
        "applyforthepermission": `相关教学活动已完成，如需继续使用超大班开展授课，请联系 <span style="font-weight: bold;">yuketang@xuetangx.com</span> 重新申请相关权限。`,
        'viewhelp': '查看帮助'
    },

    //学生小结
    student: {
        "transcript": "成绩单",
        "joinclassInfo": '你在 <span class="blackText">{time} </span>通过“<span class="blackText">{way}</span>”进入课堂',

        'way_qrcode':"扫二维码",
        "way_invite_code": "课堂暗号",
        "way_inclass_tips": '"正在上课"提示',
        "way_other": "其他",
        "minishare": "小程序分享",
        "viewplayback": "观看直播回放",
        "manualmark": "教师手动修改",
        "lessonreminder": "上课提醒",
        "tencentmeeting": "腾讯会议",

        "noquestions": "无习题",
        "personalscore": "个人总分",
        "averageclassscore": "班级平均",
        "timespent": "个人用时",
        "classaveragetime": "班级平均",
        "summarycorrectno": "正确题数",
        "summarywrongno": "错误题数",
        "summaryungraded": "未批改数",
        "questionsnumber": "习题数",
        "unclearslides": "不懂课件",
        "savedslides": "收藏课件",
        "markinclass": "课上标记",
        "unclear": "不懂",
        "and": "及",
        "save": "收藏",
        "afterclassreview": "课件，方便课后复习～",
        "noattendclass": "您错过了本次授课,",
        'noattendbyteacher':'老师备注你本次课缺勤',
        "tutorlesson": "记得及时补习这节课的内容哦",
        "studycontent": "学习内容",
        "noreleasedslides": "老师没有发布课件～",
        "summaryquiz": "课堂考试",
        "studentsummaryscore": "{score}分",
        "nowanswered": "未答题",

        "questiondetails": "习题信息",
        "wrongquestion": "错误习题",
        "subjectivequestion": "主观题",
        "fillblank": "填空题",
        "notanswered": "未作答",
        "youranswer": "你的选择",
        "loadmore": "加载更多",
        "allcorrectcongrats": "恭喜你本节课没有错误习题，再接再厉！",
        "ungraded": "未批改",
        "correctanswer": "正确答案",
        "unclearslides": "不懂课件",
        "studentsummarynounclearslides": "本节课没有不懂课件",
        "saveslides": "收藏课件",
        "summarynosavedslides": "本节课没有收藏课件",
        "myposts": "我的投稿",
        "learningthoughts": "学习心得",
        "writetips": "现在感觉怎么样？写下两笔吧！",
        "brilliantstudent": "优秀学生",
        "amongbeststudents": "这次名列前茅",
        "carryon": "再接再厉！",
        "underperformstudent": "预警学生",
        "encourgestudent": "这次成绩不甚理想",
        "cheerup": "要加油噢！",
        "summaryallquestions": "全部习题",
        "pagetotal": "共{count}页",


        //查看习题
        "nounderstandslide": "没有不懂的幻灯片",
        "pageno": "第{page}页",
        "subject_noanswer": "本题为主观题，您没有作答。",
        "fillblank_noanswer": "本题为填空题，您没有作答。",
        "seedetail": "查看详情",
        "thisanswer": "正确答案: ",
        "nosentclass":'课上未发布',
        "thisresult": "你的答案: ",
        "no_answer": "您没有作答.",
        "answer": "回答",
        "correct": "正确",
        "wrong": "错误",

        //查看PPT
        "allslides": "全部",
        "nostoreslide": "没有收藏的幻灯片",
        "toup_noanswer": "本题为投票，没有正确答案。",
        "fullscreenexit": "轻触黑色区域即可退出全屏",

        //查看学生主观题详情页
        "myscore": "得分（本题{score}分）",
        "score": "分",
        "remark": "评语",
        "no_setscore": "老师暂未打分",
        "answeranaly": "答案解析",
        "seeanaly": "查看解析",
        'acrossSingleChoice':'当前为横屏模式，请在竖屏情况下查看作答情况',
        "myanswer": "我的答案",
        "close": "关闭",
        "answertype_group": "小组作答",
        "newscore": "分数",
        "blanksnotanswer": "有空格未填写，确认提交吗？",

        "screenshot": "截图分享",
        "blackboard": "板书分享",
        "lessonshare": "课堂分享",
        "liveplayback": "直播回放",
        "boardplayback": "课程回放",
        "haveliveclickcheck": "本次授课有直播回放，点击查看",

        'fulltext': "全文",
        'fold': "收起",

        // 学生接收器回放
        "undone": "未完成",
        "done": "已完成",

        "pno": "第{number}页",
        "totalprob": "共{number}题",

        "unknown": "不懂",
        "favorite": "收藏",

        "newprob": "Hi,你有新的课堂习题",
        "newvote": "Hi,你有新的投票",
        "recvbonus": "Hi，本题有课堂红包发送",
        "gainbonus": "{number}位同学已赢得课堂红包",
        "cantintoteam": "当前是协同教师身份，不参与分组",
        "cantintoteam2": "你不在本组，无权限进入",

        "sharepostpush" : "Hi, 老师正在分享课堂投稿",
        "sharesubjective" : "Hi, 老师正在分享主观题答案",
        "randomized": "Hi，老师进行了随机分组",
        "freegrouping": "Hi，老师进行了自由分组",
        "launchedgrading" : "Hi,老师发起了互评",
        "viewresults": "查看结果",
        "enterpassword": "输入口令",

        // socket event
        "LESSON_START": "上课啦！",
        "SHOW_PRESENTATION": "新幻灯片：{0}",
        "LESSON_FINISH": "下课啦！",
        "DANMU_ON": "老师已开启弹幕",
        "DANMU_OFF": "老师已关闭弹幕",
        "RANDOM_PICK": "随机点名选中：{0}{1}",
        "SHOW_FINISH": "幻灯片 {0} 结束放映",
        "QUIZ_FINISH": "试卷 {0} 已收卷",
        "FREE_GROUP_CANCEL": "老师取消了自由分组",
        "RANDOM_GROUP_CANCEL": "老师取消了随机分组",
        "LIVE_ON": "老师开启了直播",
        "LIVE_OFF": "老师结束了直播",
        "INTERACTIVE_ON": "老师已开启互动",
        "INTERACTIVE_OFF": "老师已关闭互动",
        "TencentInteractive_ON": "老师已开启腾讯会议",
        "TencentInteractive_OFF": "老师已关闭腾讯会议",

        "howtoprint": "如何打印课件",
        "added": "收藏成功",
        "canceled": "收藏取消",
        "cannotbecanceled": "课上不懂不支持取消",
        "nothinghere": "一无所有～",

        // 回放相关
        "videotranscoded": "回放视频正在转码生成中，请稍后查看...",
        "waiting": "直播时间长，回放生成也会较慢，请耐心等待~",
        "audioplayback": "音频播放",
        "set": "设置",
        "definition": "清晰度",
        "high": "高清",
        "standard": "标清",
        "smooth": "流畅",
        "speed": "倍速",
        "playback": "课堂直播回放",
        "watchplayback": "观看课堂直播回放",
        "fold": "收起",
        "play": "播放",
        "backtocurrent": "回到当前播放",
        "audiotranscoded": "音频转码中，请稍后…",
        "reload": "如一直不能播放，刷新本页面试试～",
        "board": "板书",
        "dataabnormal": "数据异常",
        "cannotaccesstencent": "无法获取腾讯会议回放，请通过网页端的直播回放管理-替换回放进行视频替换",
        "cannotaccesstencentstu": "当前无法获取腾讯会议回放，请联系本节课授课教师，前往网页端的回放管理进行视频替换",
        // 回放管理
        "manage": "管理",
        "audiospeed": "音频倍速",
        "savecloud": "转存至云盘",
        "downloadtip": "如需下载请访问雨课堂网页版",
        "deleteurl": "删除回放段落",
        "allcheck": "全选",
        "replayurl": "回放段落",
        "duration": "时长",
        "saving": "转存中",
        "offload": "已转存",
        "nonsupport": "不支持",
        "iknow": "我知道了",
        "notvip": "您暂未拥有会员权限",
        "viptip": "转存至云盘是会员专享功能，您暂未拥有会员权限。您可进入雨课堂公众号，发送“会员”两个字，打开收到的链接申请开通",
        "tips": "提示",
        "issaviing": "回放正在转存至云盘，稍后可登录web端去云盘查看",
        "spacefull": "云盘储存空间不足",
        "fulltip": "您的云盘剩余可用空间不足，您可以在整理出足够空间后重试",
        "deleteallreplay": "确认删除所有回放吗？",
        "deletealltip": "删除后，教师和学生在课后小结中都无法再观看本段直播回放，且不可恢复",
        "deletereplay": "确认删除该段回放吗？",
        "deletetip": "删除后，教师和学生在课后小结中都无法再观看本段直播回放，且不可恢复",
        "deletesuccess": "删除成功",
        "servicenonsupport": "服务商无法支持转存",
        "servicenonsupportdel": "当前回放段落不支持删除",
        "servicenonsupporthidden": "当前回放段落不支持隐藏",
        "repeatsave": "正在转存，不可重复操作",
        "checkinweb": "已转存，请在web端云盘中查看",
        "replayisprocessed": "回放正在生成，请稍后转存",
        "playtype1": "[音频]",
        "playtype2": "[视频]",
        "noaccess": "您不是主讲老师，暂无管理权限",
        "setviewstatus": "设置可见状态",
        "playbackentry": "直播回放入口",
        "audioplayback": "音频回放",
        "videoplayback": "视频回放",
        "confirmcloseentry": "确认关闭直播回放入口吗？",
        "closeentryresult": "关闭后，学生将无法看到全部回放段落",
        "confirmhiddenplayback": "确认隐藏该直播回放段落吗？",
        "hiddenresult": "隐藏后，该回放段落对学生不可见",
        "setsuccess": "设置成功",
        "playbackallhiddentip": "* 本次课堂的全部回放片段当前已不可查看",
        "cannotplaycuritem": "当前回放片段已被隐藏或删除，无法使用定位功能",

        // 新试卷封面
        "exam_desc": "考生须知",
        "nodesc": "暂无说明",
        "score_finished": "试卷得分",
        "score_unstart": "试卷分数",
        "wrongproblems": "错题数",
        "datishu":"大题数量",
        "xitishuliang":"习题数量",
        "problems": "题数",
        "exam_notanswer": "未作答",
        "start_time": "开始时间",
        "end_time": "截止时间",
        "end_lesson_time": "结课时间",
        "exam_limit": "考试限时",
        "exam_notlimit": "不限时",
        "answer_time": "成绩将于{time}公布",
        "exam_start": "开始答题",
        "exam_continue": "继续答题",
        "exam_notbegin": "考试未开始",
        "exam_check": "查看试卷",
        "exam_nodata": "暂无数据",
        "exam_notview": "老师设置不可查看",
        "sun": "星期日",
        "mon": "星期一",
        "tue": "星期二",
        "wed": "星期三",
        "thu": "星期四",
        "fri": "星期五",
        "sat": "星期六",
        "watchedreplay": "本节课已观看过回放",
        "partpagenoview": "部分页面当前已不可见",
        "coverentertips": "未达到考试条件",
    },

    //消息
    message: {
        "infoassignment": "任务",
        "infomessage": "通知",
        "infofollowers": "粉丝",
        "chat": "私信",
        "comment": "评论",
        "repliedToYou": "回复了你",
        "commentedOnYourComment": "评论了你",
        "likedYou": "点赞了你",
        "NoMessage": "还没有任何消息",
        "loading": "加载中",
        "nomessage": "你还没有任何消息",
        "infocoteacher": "已成为协同教师身份",
        "removecoteacher": "已被移除协同教师",

        "infopromotecoteacher": "{courseTitle}的主讲教师已提拔您为协同教师",
        "inforemovecoteacher": "{courseTitle}的主讲教师已将您移除协同教师",
        "receivepreclassinfo": "收到课前反馈",
        "inforeceivereport": "收到{feedbackCnt}条报告老师，请您查看",

        "replypreviewreport": "报告老师收到回复",
        "receiveteacherreply": "收到老师回复，速速去查看吧",
        "pullRefresh": "下拉刷新",
        "releaseUpdate": "释放更新",
        "markasread": "全部标记为已读",
        "hasMarked": "已全部标记为已读",
        "message": "消息",
        "notification": "通知",

        "infonofollowers": "你还没有任何粉丝",
        "infoyourquestionanswered": "{respondent}回答了你的提问",
        "infoquestionname": "问题是{question}",
        "inforeplytou": "评论了你的回答",

        "noassignment": "你还没有任何任务",
        "publishslidespush": "{teacherName}老师发布了新课件",
        "published": " 已发布",
        "slidesddlpush": "{deadline}请尽快完成",
        "previewpush": "在{deadline}之前完成噢",
        "unclearremind": "课堂上遗留了不懂",
        "figureoutunclears": "别把问题留到下节课，赶紧消灭吧",
        "publishquizpush": "{teacherName}老师发布了新试卷",
        "publishedpush": "抓紧时间尽快完成吧",
        "assignmentddlpush": "在{deadline}之前完成作业噢",
        "inforeceiveslidespush": "{courseTitle}-{chapterTitle}{sectionTitle} 已到达，可以开始学习啦",
        "unclearset": "课堂不懂集中反馈",
        "checkstudentunclear": "学生有部分存疑，去看看吧",
        "infobeinvited": "{inviter}邀请您回答问题",
        "newLearnWarnningTitle": "{inviter}老师提醒你关注学情",
        "newLearnWarnningContent": "请关注你的课程学习情况，在结课前尽快提升成绩",
        "booking_down": "预约的新章节到了",
        "image": "图片",
        "NoMessageTips": "你可在班级内的成员列表处点击头像发送私信",

        "commentdel": "内容已被删除"
    },

    //教师端页面
    teacher: {
        "yijiaojuan": "已交卷",
        "weijiaojuan": "未交卷",
        "unclearlist": "“不懂”名单",
        "standardopt": "本题正确选项为:",
        "nameone": "姓名",
        "optionone": "选项",
        "notansweredone": "未作答",
        "wrongquestionone": "习题“错误”",
        "slidewrongone": "课件“不懂”",
        "studentnumber": "人数",
        "wrongone": "错误: ",
        "unclearone": "不懂: ",
        "uncleartwo": "不懂",
        "searchone": "搜索",
        "rankingone": "排名",
        "totalscoreone": "总分",
        "timespentone": "用时",
        "questionandpage": "题号/页码",
        "tihao": "题号",
        "correctanswertwo": "正确答案",
        "submitone": "提交选项",
        "submit": "提交",
        "correctanswerthree": "正确答案",
        "scoreone": "得分",
        "subjectivequestionone": "主观题",
        "inclassquiz": "课堂考试",
        "notansweredtwo": "未答题",
        "notansweredblanks": "未答",
        "detailsone": "详情",
        "checkone": "查看",
        "sentokone": "已成功发送至",
        "sentoktwo": "已成功送达：",
        "scheduledeliverfailedone": "预约发送失败，请重新发送",
        "publishname": "发布名称",
        "quizone": "试卷",
        "timetopublish": "发布时间",
        "timetopublish1": "发布时间",
        "deadlineone": "截止时间",
        "quizdurationone": "考试时长（分钟）",
        "releasetimeone": "公布答案时间",
        "publishclassone": "发布班级",
        "totalclassesone": "共 {length} 个班",
        "pagetotal": "共{count}页",
        "deletepublishone": "删除本次发布",
        "cancelone": "取消",
        "okone": "确定",
        "delete": "删除",
        "confirmone": "确认",
        "publishinstruction": "发布{\"试卷\" : \"课件\"}帮助说明",
        "setdeadlinetips": "若设定完成截止时间，到期后学生将不能答题，完成后数据也不再更新，但在课件查看截止时间内仍能查看课件；",
        "nosetdeadlinetips": "若不设定完成截止时间，学生在课件查看截止时间内随时可以查看课件并答题，完成后数据将实时更新；",
        "systemsubmitanswers": "设定截止时间后，到期学生将仍能看到试卷，但无法继续作答或提交试卷，试卷完成数据及得分分布也不再更新。到截止时间时，系统将自动提交学生所作答的全部内容。",
        "timernostop": " 学生必须在规定的时间长度内提交试卷。点击作答开始计时，若中途退出，计时不停止。到时后系统将自动提交学生所作答的全部内容。",
        "releasetips": "正确答案将在到达此时间时向学生公布，在此之前，学生即使提交试卷也无法知晓正确答案及相关答案解析。",
        "close": "关闭",
        "publish": "发布",
        "none": "无",
        "publishnow": "立即发布",
        "": "[\"日\",\"一\",\"二\",\"三\",\"四\",\"五\",\"六\"]",
        "notimelimitone": "不限时",
        "showaftersubmission": "交卷后立即显示",
        "nochooseclass": "您还未选择发布的班级",
        "publishtimenoearliernow": "发布时间不能早于当前时间",
        "ddltimenoearliernow": "截止时间不能早于当前时间",
        "": "当前截止时间过早，不满足考试时长",
        "testdurationzero": "考试时长不能为0",
        "noearlierthanpublishtime": "截止时间应在发布时间之后\r\n请重新设置",
        "changecfmone": "是否确认修改发布信息",
        "publishcfmone": "确认发布到班级",
        "deletecfmone": "是否确认删除本次预约",
        "hour": "小时",
        "min": "分钟",
        "": "点",
        "today": "今天",
        "tommrrow": "明天",
        "thedayaftertommorrow": "后天",
        "tips1": "提示：课件中含有习题，您可以在此设置公布答案的时间",
        "chengjidantips": "系统将根据考核设置自动出成绩，您可以在网页端“班级成绩单”模块查看或管理班级考核方案。",
        "monthdayweek": "月 日 周",
        "anonymouspollnodetail": "本题为匿名投票，不显示投票人",
        "numberofvotes": "{count}票",
        "standardopt": "本题正确选项为: ",
        "numberofstudents": "{count} 人",
        "numberofstudents1": "人",
        "noanswers": "还没有学生作答",
        "answerdetails": "答题情况",
        "submittime": "完成时间",
        "numberviewedpage": "已查看页数",
        "content": "内容",
        "senttime": "发送时间",
        "saved": "已收藏",
        "save": "收藏",
        "whatispost": "什么是投稿？",
        "post": "投稿",
        "coteacherinclass": "本班协同教师",
        "addcoteacher": "添加协同教师",
        "setpermission": "设置权限",
        "deletepermissioncfm": "确认删除该老师权限吗?",
        "deletepermissionfailed": "删除该老师权限失败",
        "selectall": "全选",
        "confirmdelete": "确认删除",
        "": "此课程选课信息由教务系统直接导入雨课堂中,只可对旁听生进行管理",
        "managestudents": "学生管理",
        "clear": "清空",
        "readnumber": "人已读",
        "unreadnumber": "人未读",
        "slidecover": "雨课堂课件封面",
        "slidename": "演示文稿名称",
        "yearmonthday": "年 月 日",
        "selectclass": "选择班级",
        "done": "完成",
        "addnewclassinjoined": "添加新班级请到我的课程管理添加",
        "enterslidetitle": "请输入课件名称",
        "noclasschosen": "您还未选择发布班级",
        "publishfailed": "发布失败",
        "selectclasstopublish": "选择发布班级",
        "nocreatedcourse": "您还没有创建课程",
        "createaacourse": "创建课程",
        "noclassyet": "课程无班级,请增加班级",
        "tocreatecourse": "去新建课程",
        "selectclassplease": "请选择班级",
        "announcementlimit": "每班每日可发送2条公告，你还可以发送",
        "anouncementnumbers": "条",
        "requiredtitle": "标题(必填)",
        "spaceorentertosend": "您可以向学生发送文字、图片、链接（请在输入链接地址的前后，均添加空格或回车以确认）",
        "sendto": "发送至：",
        "backtoedit": "返回编辑",
        "confirmok": "确定发送",
        "classesreceiveok": "已成功发送给以下班级：",
        "gotit": "我知道了",
        "deletepiccfm": "确定删除图片？",
        "quiteditcfm": "是否放弃本次编辑?",
        "noannouncementcansend": "您还可以发送0条",
        "titlenotnull": "标题不能为空",
        "announcementnotnull": "公告不能为空",
        "reachupperlimit": "该班级已经超过发送次数，不能发送。",
        "announceanswertip": "说明：答案将在此日期后公布，否则提交后直接显示",
        "notimelimitdetail": "不限时 5分钟 15分钟 30分钟 45分钟 60分钟 90分钟 120分钟 150分钟 4小时 6小时 8小时 12小时 24小时 48小时",
        "enterquizname": "请输入试卷名称",
        "setdateaftertoday": "请设置今天之后的日期",
        "teachingdatapoll": "投票",
        "chooseupperlimit": "最多可选",
        "teachingdataoption": "项",
        "multiplem": "多选题",
        "multiples": "单选题",
        "subjectivepro": "主观题",
        "point": "分",
        "anonymouspollnodetail": "本题为匿名投票，不显示投票人",
        "votenumber": "票",
        "standardopt": "本题正确选项为",
        "notansweredone": "未作答",
        "teacherdatastudents": "人",
        "teacherdatastudentscount": "{count}人",
        "zuodashichang": "作答时长",
        "weidatitishi": "*未答题不包含未签到的学生",
        "noanswers": "还没有学生作答",
        "answerdetails": "答题情况",
        "noaddslides": "您还没有添加任何课件喔",
        "year": "年",
        "month": "月",
        "day": "日",
        "deadline": "截止时间",
        "enterslidenameplease": "请输入课件的名称",
        "datedetail": "年／月／日",
        "slidepublish": "课件发布",
        "sending": "正在发送...",
        "noaddtests": "您还没有添加任何试卷喔",
        "selectslideoneonly": "选择课件(单选)",
        "coursechooseslide": "选择试卷(单选)",
        "sendnow": "立即发出",
        "testduration": "考试时长(分钟)",
        "notimelimitone": "不限时",
        "releasetimeone": "公布答案时间",
        "showaftersubmission": "提交后立即显示",
        "announceanswertip": "说明：答案将在此日期后公布，否则提交后直接显示",
        "cfmpublish": "确认发布",
        "publishtest": "试卷发布",
        "setdateaftertoday": "请设置今天之后的日期",
        "sending": "正在发送...",
        "notimelimitdetails ": "不限时 5分钟 15分钟 30分钟 45分钟 60分钟 90分钟 120分钟 150分钟 4小时 6小时 8小时 12小时 24小时 48小时",
        "donealready": "已完成",
        "checkedpreview": "已查看",
        "nocheckedpreview": "未查看",
        "noonefinishpreview": "还没有学生完成",
        "noonepreviewing": "还没有学生正在进行",
        "allfinish": "全部学生已完成",
        "previewdetail": "完成情况",
        "finisheddetails": "完成情况",
        "finishedpreview": "已完成",
        "checkslides": "查看课件",
        "viewdetails": "查看详情",
        "studentscheckedslides": "查看课件人数",
        "totalclassstudents": "班级总人数",
        "answerdetails": "答题情况",
        "subjectivepro": "主观题",
        "gradingrate": "批改率",
        "answerrate": "答题率",
        "averagescore": "平均分",
        "poll": "投票题",
        "grading": "批改",
        "webgradetips": "温馨提示：网页版（{url}）批改主观题更便捷",
        "accuracy": "正确率",
        "objectivequestion": "客观题",
        "answerrate": "答题率",
        "teacherdatacheck": "查看",
        "studentfeedback": "学生反馈",
        "anonymous": "匿名",
        "unread": "未读",
        "nostudentfeedback": "目前还没有学生反馈信息",
        "detaileddata": "详细数据",
        "webdownloadexcel": "下载多次Excel数据 请登录网页版 {url}",
        "teachingdesign": "教学设计与备忘",
        "teachingdesigntip": "您可以在这里可以记录教学设计和心得等笔记，内容仅自己可见",
        "editpublishtitle": "编辑发布标题",
        "deletepublish": "删除本次发布",
        "loadmore": "加载更多",
        "mailreceivedata": "本次详细数据将会发送至以下邮箱",
        "enterfrequentmail": "请你输入常用邮箱",
        "mailformaterror": "邮件格式错误",
        "datasentok": "数据已发送",
        "yktwebtips": "温馨提示：在雨课堂网页版 {url}",
        "enternewtitle": "输入新的标题~",
        "deletepulishcfm": "是否删除本次发布",
        "deletepublishfailed": "删除发布失败",
        "previewdetails": "学习详情",
        "finisheddetails": "完成详情",
        "gradingdetails": "批改详情",
        "name": "姓名",
        "score": "得分",
        "submission": "交卷时间",
        "gradingtime": "批复时间",
        "noonefinished": "还没有学生完成",
        "testfinisheddetails": "试卷完成情况",
        "finisheddetails": "完成情况",
        "checktestpaper": "查看试卷",
        "graded": "已批改",
        "finishedtest": "完成试卷",
        "checktestpaper": "查看试卷",
        "totalstudentone": "班级人数",
        "viewdetails": "查看详情",
        "scoredistribution": "总分分布",
        "allvote": "此试卷全部为投票题",
        "ungradedsubjectiveproexist": "您还有主观题尚未批改",
        "clickbarcharttograde.": "点击下面主观题柱状图进行批改",
        "noonefinishedtest": "还没有学生完成试卷",
        "qbxsyjj": "全部学生已交卷",
        "answerdetails": "答题情况",
        "grading": "批改",
        "deleteexcelnow": "可直接下载多次详细数据的Excel文件哦～",
        "deletepulishcfm": "是否删除本次发布",
        "deletepublishfailed": "删除发布失败",
        "standardopt": "本题正确选项为",
        "noanswerforpoll": "本题为投票，没有正确答案",
        "option": "选项",
        "name": "姓名",
        "loadingdata": "正在加载数据...",
        "answered": "已作答",
        "notansweredone": "未作答",
        "lessonexciese": "课堂习题",
        "lessonquiz": "课堂试卷",
        "score": "得分",
        "gradeone": "打分",
        "stick": "条",
        "loadmore": "加载更多",
        "okone": "确定",
        "thisquestion": "本题",
        "point": "分",
        "cancel": "取消",
        "positivescore": "分数必须为正数",
        "exceedmaximumscore": "分数超过最大本题分值，请重新输入",
        "keepadecimal": "分数最多保留一位小数，请重新输入",
        "numberonlywarning": "所输分数必须为数字，请重新输入",
        "unclearstudents": "不懂人数",
        "unclearstudents1": "不懂人数<span class=\"font18\">{count}</span>人",
        "noquestiontoanswer": "本堂课没有习题",
        "nounclearslides": "没有被点击『不懂』的课件",
        "nocommentslides": "没有带「评论」的幻灯片~",
        "commentcount": "评论条数",
        "quantityone": "红包个数：",
        "noquestiontoanswer": "本堂课没有习题",
        "standardopt": "本题正确选项为:",
        "noanswerforpoll": "本题为投票，没有正确答案",
        "gradingtime": "批复时间",
        "timelimitedtest": "本套试卷限时",
        "min": "分钟",
        "deadline": "截止日期",
        "testdeadline": "本套试卷截止时间",
        "timelimitedtest": "本套试卷限时",
        "checkhw": "查看作业",
        "finishedhw": "已完成作业",
        "hwfinisheddetail": "作业完成情况",
        "finishedhwstudent": "n位同学完成作业",
        "gradedhwnumber": "份作业已经批复",
        "scorereport": "得分情况",
        "questionlocate": "第2题",
        "accuracyone": "正确答题率",
        "editpublishtitle": "编辑本次发布标题",
        "deletepublish": "删除本次发布",
        "deletepublishone": "确认删除本次发布吗?",
        "deletepublishfailed": "删除发布失败",
        "mailreceivedata": "本次详细数据将会发送至以下邮箱",
        "enterfrequentmail": "请你输入常用邮箱",
        "datasentok": "数据已发送",
        "submission": "交卷时间",
        "searchname": "搜索姓名",
        "checktestpaper": "查看卷面",
        "randomrollcallinthisclass": "本节课随机点名",
        "signedinstudent": "已签到",
        "totalsignedstudent": "共2人",
        "signin": "签",
        "dot": "点",
        "person": "人",
        "ci": "次",
        "nistudenttocall": "没有点名学生～",
        "correctopt": "正确选项",
        "wrongopt": "错误选项",
        "anonymouspollnodetail": "本题为匿名投票，不显示投票人",
        "totalamountofbonus": "总金额",
        "rmb": "元",
        "bonusnotopened": "未领取",
        "notansweredtwo": "未答题",
        "votemost": "投票题，最高得票选项为：",
        "standardopt": "本题正确选项为",
        "voteoption": "投票的选项",
        "nostudentanswered": "还没有学生答题",
        "studentfinishedpreview": "已完成",
        "previewdetail": "课件学习情况",
        "finishpreview": "完成学习",
        "privateteachingnote": "您可以在这里记录教学设计和心得等笔记，内容仅自己可见。",
        "mailreceivedata": "本次详细数据将会发送至以下邮箱",
        "activestudent": "课堂人数",
        "enterclass": "进入课堂",
        "activestudentnumber": "进入课堂人数",
        "totalclassstudent": "班级总人数",
        "studentdata": "学生数据",
        "notfinalrank": "有主观题未批改，此排名可能不是最终排名",
        "totalrank": "全部排名",
        "notfinalrank": "有主观题未批改，此排名可能不是最终排名",
        "brilliantstudent ": "优秀学生",
        "timespenttwo": "用时",
        "warningstudent": "“预警\"学生",
        "trackstudentprogress": "在课堂上通过习题更好了解学生状态~",
        "studentanswerdata": "习题数据",
        "barcharttograde": "（点击柱状图可批改）",
        "totalquestions": "全部习题",
        "teachingunclearpage": "点不懂页数",
        "teachingtotalslidesno": "课件总页数",
        "teachingsubjectiveproungraded": "有主观题未批改",
        "classdanmu": "课堂弹幕",
        "classpost": "课堂投稿",
        "randomrollcall": "随机点名",
        "senddetaileddata": "发送详细数据",
        "teachingcontents": "教学内容",
        "totalpagenumber": "共1页",
        "teachingdesign": "教学设计与备忘",
        "privateteachingnote": "您可以在这里记录教学设计和心得等笔记，内容仅自己可见。",
        "coteacherlimit": "协同教师无法删除此教学活动",
        "deletepublishone": "确认删除本次发布吗",
        "coteacherlimit": "协同教师无法删除此教学活动",
        "deletefailedretry": "删除失败，请稍后重试",
        "one": "个",
        "countone": "{count}个",
        "tipsdownloadwebdata": "温馨提示：在雨课堂网页版 {url}可直接下载多次详细数据的Excel文件哦～",
        "notsignedin": "未签到",
        "total": "全部",
        "totalone": "共",
        "pro": "习题",
        "teachingcheck": "查看结果",
        "slidesdetail": "课件数据",
        "quizedit": "修改",
        "comment": "评语",
        "good": "写得不错",
        "comeon": "继续加油",
        "uniqueidea": "想法很独特",
        "excellent": "小红花",
        "enterscoretip": "请输入分值",
        "comment": "评语",
        "invaildinput": "输入无效，请重新输入",
        "positivescore": "分数必须为正数",
        "exceedmaximumscore": "分数超过最大本题分值，请重新输入",
        "sendprotips": "怎样布置习题？",
        "slidesdetails": "课件数据",
        "emptyhelp": "戳这里看帮助",
        "emptysildes": "还没有上传的课件",
        "emptysildesupload": "尝试从电脑端上传课件吧",
        "emptyquiz": "还没有上传的试卷",
        "emptyquizupload": "尝试从电脑端上传试卷吧",
        "studentsVisible": "学生可见",
        "visibleAll": "全部课件",
        "visibleStu": "课上讲解的",
        "visibleAllnot": "全部不可见",
        "visiblepart": "部分可见",
        "pointnotviewpage": "点击选中不可见的页面",
        "nocheck": "不可见",
        "editviewpage": "编辑可见页面",
        "stucheckauth": "学生查看权限",
        "ppt_limit_ques1": "确认学生可见<span style='color: #333;font-weight: 500;'>“全部课件”</span>吗？",
        "ppt_limit_ques2": "确认学生只可见<span style='color: #333;font-weight: 500;'>“课上讲解部分的课件”</span>吗？",
        "ppt_limit_ques3": "确定课件对学生<span style='color: #F84F41;font-weight: 500;'>“全部不可见”</span>吗？",
        "nextDefault": "下次授课默认使用该选择",
        "setSuc": "设置成功",
        "lookLimit": "查看限制",
        "paperLookLimit": "试卷查看限制",
        "alwaysLook": "始终可见",
        "afterHand": "交卷后不可见",
        "afterHandTips": "截止后，未交卷学生也不可见",
        "afterCannot": "设置不可见后，学生将无法查看试卷内容，仅可查看答题结果。",
        "changeForNot1": "更改截止时间后，仅对未交卷学生生效。",
        "changeForNot": "更改完成截止时间后，仅对未完成学习的学生生效。",
        "addBlack": "加入黑名单（加入黑名单后该学生将无法再加入班级）",
        "blackList": "黑名单",
        "haimeiyouStu": "还没有学生<br/>赶紧邀请学生加入班级～",
        "checkblackList": "查看黑名单",
        "remove": "移出",
        "confirmRemove": "确定将学生移出黑名单吗？",
        "removeTips": "移出后，学生可通过扫码、输入课堂暗号等方式加入班级",
        "quanweida": "还没有学生作答",
        "quanyida": "您的学生已全部作答",

        // 打分
        "newtotalscore": "本题总分{total}分",
        "hupingtotalscore": "本题总分{total}分，互评占比{groupReviewProportion}%，教师占比{teacherProportion}%",
        "finalscore": "最终得分",
        "teachergrading": "教师评分",
        "peergrading": "互评得分",
        "totalmembers": "共{num}人",
        "noComment": "暂无评语",
        "newpoint": "分",
        "fulltext": "全文",
        "fold": "收起",
        // 填空题
        "correctcount": "正确人数",

        "sendtokfail": "个班级未送达",
        "sentokthree": "未送达班级：",
        "touchtoresend": "（可点击班级右侧按钮重新发送）",
        "touchtoresend2": "（非受限班级可点击右侧按钮重新发送）",

        // 手动批改填空题
        "showquestion": "查看题目",
        "tocorrect": "确定修改为正确吗？",
        "addcorrectanswer": "添加为正确答案（同时重新批改其他同学的作答）",
        "regradeanswers": "选中学生可手动批改填空题",
        "submitone2": "提交答案",
        "notallow": "本题答案允许乱序，暂无法直接添加为正确答案",

        "nonickname": "未设置昵称",

        "tips2": "提示：延长考试截止时间，仅对未交卷的学生有效。对自动交卷或被系统自动收卷的学生不生效。",
        "watchedreplay": "观看回放人数",
        "replayed": "观看回放",
        "signinempty": "没有学生签到",
        "unsignempty": "没有学生未签到",
        "watchempty": "没有学生观看了回放",

        "xingmingzimu": "按姓名首字母",
        "xuehaoxiaodaoda": "学号从小到大",
        "xuehaodadaoxiao": "学号从大到小",
        "meiyoushuju": "没有数据了",
        "clickloadmore": "点击加载更多",
        "live": "直播数据",
        "livemin": "分钟",
        "totalduration": "总在线时长：",
        "liveduration": "时长：",
        "online": "在线：",
        "livetip": "总在线时长指本次授课中所有加入互动直播的用户在线时长之和（包括老师），雨课堂以此总时长计算消耗的流量。",
        "hideproblemtips": "超过3000人班级暂不展示习题数据。",
        "txmeetingsuccess": "腾讯会议回放已保存到雨课堂",
        "txmeetingfail": "腾讯会议回放未保存到雨课堂",
        "txmeetingcannotdel": "回放视频未保存到雨课堂，在腾讯会议中删除将无法恢复，请谨慎删除",
        "txmeetingcandel": "回放视频已保存到雨课堂，在腾讯会议中删除不影响回放的正常观看",
    },
    //群发公告
    pubnotice: {
        'successTop':'置顶成功',
        'successCancle':'取消置顶成功',
        'failTop':'置顶失败',
        'failCancle':'取消置顶失败',
        "showall": "显示全文",
        "totalattachment": "共有{length}个附件",
        "downloadfromyktweb": "可在网页版{url}下载",
        "delannoucement": "删除本次公告",
        "teachernameann": "{teacherName}老师发布的公告",
        "ykt": "雨课堂",
        "noundocfm": "删除后将不可恢复",
        "confirmdel": "是否确认删除此公告？",
        "fileunablepreview": "该格式文件无法预览",
        "readynum": "{ready_num}人已读",

        'commenttitle':'确认删除此评论？',
        "replytitle": '确认删除此回复？',
        "delreplyreplyoptions": '删除后不可恢复',
        "delcommentoptions": '删除后将不可恢复，评论下的回复也将一并删除。',

        "announcementlimit": "每班每日可发送2条公告，",
        "announcementquota": "你还可以发送",
        "msunit": "条",
        "titlerequired": "标题(必填)",
        "selectTime": "选择发送时间",
        "sendannouncementtips": "你可以直接输入文字向学生发布公告，也可以通过分享链接的方式，向学生推荐网页。",
        "cancel": "取消",
        "send": "发送",
        "sendto": "发送至：",
        "title": "标题",
        "backtoedit": "返回编辑",
        "cfmtosend": "确定发送",
        "sendok": "发送成功",
        "notempty":'公告正文不能为空',
        "gotit": "我知道了",
        "sendoktoclass": "已成功发送给以下班级：",
        "publishannouncement": "发布公告",
        "delpiccfm": "确定删除图片",
        "exiteditcfm": "是否放弃本次编辑?",
        "timerequred": "发布时间必须填写且不能早于当前时间",
        "unabletosendannouncement": "您还可以发送0条",
        "titlenullwarning": "标题不能为空",
        "announcementnullwarning": "公告不能为空",
        "golimit": "该班级已经超过发送次数，不能发送。",


        "allclass": "{course_name}的所有班级",
        "entertitle": "请录入通知标题",
        "entercontent": "请录入通知内容",
        "selectclassplease": "请选择班级",
        "faileduploadnotsend": "上传失败的附件将不会被发送",

        "selectclasstopublish": "选择发送班级",
        "selectedclass": "已选班级",
        "cancel": "取消",
        "announcementok": "确定",
        "maxfilesize": "可上传10个附件，单个文件不超过30M，累计不超过100M",
        "attachnumberselected": "已选择{ilen}个附件",
        "fileselectleft": "还可选择{ilen}个文件",
        "addattachedment": "添加附件",
        "del": "删除",
        "reupload": "重新上传",
        "uploadfailed": "上传失败",
        "delundocfm": "删除后将不可恢复，是否确认删除？",
        "maxuploadfilenumber": "一次最多可上传{max_fileCount}个文件",
        "totaluploadmaxsize": "累计上传附件不超过{totalFileSize}M",
        "waiting": "等待...",
        "uploadcompleted": "上传完成",
        "filesizeexceedlimit": "文件大小超过限制",
        "fileformatlimit": "文件格式不符合要求",
        "sendtofollowingclass": "发送到以下班级：",
        "edit": "编辑",
        //web端群发公告添加
        "maxcharnum_tip":"您已输入{ilen}个字符，超过最大10000字符限制<br/>请适当缩减公告内容",
        "cannotoplink": "无法打开超链接",
        "miniprogramtip":"小程序无法打开外部链接，如公告中含有超链接，请您在雨课堂公众号中查看",
        "miniprogramhelp":"如何操作",
        "clickShowClasses_1": "点击",
        "clickShowClasses_2": "可展开该课程的全部班级",
        "noRight": "你没有权限向此班级发布公告",
        "webuptips": "温馨提示：Web端发公告可以上传附件噢~",
        "topNotice":'置顶本公告',
        'cancleNotice':'取消置顶',
        "cancelTop":'取消置顶',
        "sendclass": "发送班级",
        "addclass": "添加班级",
        "noticetitle": "公告标题",
        "titleplaceholder": "请输入通知标题",
        "linktips": "提示：若手动输入链接地址，请在链接地址前后均添加空格或回车以确认。",
        "previewsend": "预览并发送",
        "createnew": "创建群发公告",
        "archiveclass": "有班级已归档，需要发送公告请先将其移出归档"
    },



    // 图片资源
    img: {
        empty_colletion: "https://qn-sfe.yuketang.cn/o_1c2tq4l86182t1r0jv3dvgb1c99e.png",
        empty_class: "https://qn-sfe.yuketang.cn/o_1c2vgq3pi1299dfp1g1imd5tjmj.png",
        empty_student_blank: "https://qn-sfe.yuketang.cn/o_1c2vgqthm1imkk9rakp9h91pvco.png",
        empty_score_detail: "https://qn-sfe.yuketang.cn/o_1c2vi8omc1m8nd2d1h0mqfjfsjt.png",
        empty_task: "https://qn-sfe.yuketang.cn/o_1c2vis7le1mdm3nessckvl1g08o.png",
        empty_msg: "https://qn-sfe.yuketang.cn/o_1c2vjnbud9u51kd61vqs18p2stst.png",
        notice_delete: "https://qn-sfe.yuketang.cn/o_1c2vjvlnktmv192vhlm1mnhi0q12.png",
        notice_forbidden: "https://qn-sfe.yuketang.cn/o_1c2vjvqn8dnk1cu8ag0rc87op17.png",
        notice_alllook: "https://qn-sfe.yuketang.cn/o_1c2vv7qcv16thqlq1q1h1qkb1dcka.png",
        notice_allnotsee: "https://qn-sfe.yuketang.cn/o_1c2vv7qcv8os14r1jmf1b6s1455b.png",
        tougao_student: "https://qn-sfe.yuketang.cn/o_1c2vthnov1a761h2acpd29t1oqmf.png",
        tougao_teacher: "https://qn-sfe.yuketang.cn/o_1c2vthnov10cck5t1cil16upbohg.png",
        empty_teach_log: "https://qn-sfe.yuketang.cn/o_1bkduf96pgadvdbr7m1afi8v09.png",
        empty_store: "https://qn-sfe.yuketang.cn/o_1c2vui47hujgkrvf9e1tjssb9e.png",
        empty_bill: "https://qn-sfe.yuketang.cn/bill_empty.png",
        empty_paper: "https://qn-sfe.yuketang.cn/o_1c3009o01vqnbqnh5h1d5a1ndo9.png",
        learning_complete: "https://qn-sfe.yuketang.cn/o_1c300rq1h1fhj1rki1ppt1smdjb19.png",
        learning_uncomplete: "https://qn-sfe.yuketang.cn/o_1c300s1if1j7k5cb1lsm1g3p64ke.png",
        teacher_allsign: "https://qn-sfe.yuketang.cn/o_1c303acid1q1rpcr1bj21asjnqv12.png",
        teacher_allnotsign: "https://qn-sfe.yuketang.cn/o_1c303a45v1qiem573qumkj8hot.png",
        gkk_log_empty: "https://qn-sfe.yuketang.cn/o_1c30503dk1utp9pv8hrdtki1k1c.png",
        fans_empty:"https://qn-sfe.yuketang.cn/o_1c5ku05jr1tccqc2191bq0nunfe.png",
        batch_log: "https://qn-sfe.yuketang.cn/o_1emtrsdqrvvi1u5c16mov1m1s1ja.5x.png",
        noupload_img: "https://qn-sfe.yuketang.cn/o_1fu69dk831e8mpgbu0j4251l4kf.png",
        noupload_img_shu: "https://qn-sfe.yuketang.cn/o_1fu69dk831d48m061lttmh2e7rd.png",
    },

    // 错误提示信息
    error: {
        "contentdel": "此内容已被老师删除。",
        "checkfromactivity": "请从班级学习日志中查看课件。",
        "noauthslides": "啊噢，你没有权限查看此课件。",
        "classdel": "您已删除此班级。",
        "nocontent": "你想访问的内容不存在",
        "cannotlearnclassend": "当前课程已结课 无法继续学习啦",
    },
    //课件、试卷文件夹管理
    my_folder_manage:{
        'notempty': '名称不可为空',
        "myupload":"我上传的",
        "myreceived":"我收到的",
        "chosequiz":"选择试卷",
        "singlechose":"单选",
        "choseslide":"选择课件",
        "noslide":"还没有上传的课件",
        "tryuploadslide":"尝试从电脑端上传课件吧",
        "nouploadquiz":"还没有上传的试卷",
        "tryuploadquiz":"尝试从电脑端上传试卷吧",
        "seehelp":"戳这里看帮助",
        "createOK":"创建成功",
        "updateOK":"修改成功",
        "noslidereceived":"还没有收到的课件",
        "inyourclass":"你所在班级里的",
        "inyourclass_quiz":"你所在班级里的",
        "mobileslide":"手机课件",
        "and":"和",
        "lessonslide":"课堂授课的课件",
        "comehere":"都会出现在这里",
        "noquiz":"还没有收到的试卷",
        "mobilequiz":"手机试卷",
        "lessonquiz":"课堂授课的试卷",

        "newfolder":"新建文件夹",
        "newfolderlimit": "新建文件夹（64字以内）",
        "movefolder":"移动到文件夹",
        "deletequiz":"删除试卷",
        "deleteslide":"删除课件",
        "management":"管理",
        "foldername":"请输入文件夹名称",
        "complete":"完成",
        "inputlenlimited":"名称限制12个汉字，请重新输入",

        "folderempty":"这个文件夹是空的",
        "folderempty1":"你可以将课件库的课件移动到文件夹里以方便管理",
        "folderempty1_quiz":"你可以将试卷库的试卷移动到文件夹里以方便管理",
        "renamefloder":"重命名文件夹",
        "renamefloderlimit":"重命名文件夹（64字以内）",
        "renamefile": "重命名（64字以内）",
        "filename": "请输入...",
        "moveoutquiz":"移出试卷到",
        "moveoutslide":"移出课件到",
        "deletefolder":"删除文件夹",
        "deletefoldertip":"删除文件夹，将同时删除文件夹内的所有课件。",
        "tips":"提示",
        "deleteok":"删除成功",

        "chosefolder":"选择要移动到的文件夹",
        "mycollections":"我的课件库",
        "rootdir":"根目录",
        "move":"移动",
        "choseonefolder":"请选择一个文件夹",
        "moveok":"移动成功",

        "chosealready":"已选: ",
        "nextstep":"下一步",
        "deleteslidetip":"删除已选{selectCount}个课件？",
        "deletequiztip":"删除已选{selectCount}个试卷？",
        "deleteslidesingletip":"是否删除已选课件？",
        "deletequizsingletip":"是否删除已选试卷？",
        "swipLeftDelRename": "左滑可删除课件或重命名课件名称",
        "swipLeftDelRename1": "左滑可删除试卷或重命名试卷名称",
        "rename": "修改名称",
        "toolong": "字数超长，保存失败",
        "delete": "删除",
        "random": "随机",
        "updateApp": "更新APP版本后可参加在线监考",
        "dati": "大题",
        "zuhe": "组合卷",
        "paperPublishTips": "组合卷设置有误，无法发布",
    },

    // 习题集
    problemset: {
        "myquestions": "我的习题集",
        "wrongquestionno": "错题数",
        "totalquestionno": "总题数",
        "errorrate": "错误率",
        "questionupdatetime": "更新时间",
        "total": "全部",
        "wrongquestion": "错题",
        "markquestions": "加星题",
        // "tests": "试卷",
        // "slides": "课件",
        "viewhistory": "继续上次浏览",
        "noquestion": "你还没有习题",
        "nowrongquestion": "你还没有错题",
        "nomarkquestion": "你还没有加星题",
        "questionno": "第{index}题",
        "mark": "加星",
        "viewdetails": "查看详情",
        "takenotes": "记笔记",
        "redo": "重新做",
        "goanswering": "去作答",
        "answerdetails": "答题详情",
        "correctanswer": "正确答案",
        "answerforfirsttime": "您首次做题的答案",
        "correct": "正确",
        "wrong": "错误",
        "answernotreleased": "老师暂未公布答案",
        "notanswered": "未作答",
        "score": "得分",
        "point": "本题{count}分",
        "specificstudentscore": "{count}分",
        "comment": "评语",
        "answerkey": "答案解析",
        "myanswer": "我的答案",
        "redotips": '"重新做"只用于帮您自测，新的结果<br/>不会提交给老师。',
        "gotit": "知道了",
        "comfirm": "确定",
        "answercorrect": "回答正确",
        "answerwrong": "回答错误",
        "note": "笔记",
        "takenotestips": "您可以在这里记录考点及心得，内容仅自己可见",
        "save": "保存",
        "edit": "编辑",
        "checknotes": "看笔记",
        "nosetscore": "老师暂未打分",
        "datacollecting": "数据正在收集中...",
        "noqustions": "你还没有习题",
        "groupanswered": "小组作答：",
    },

    plupload:{
        'Select_files' : '选择文件',
        'Add_files_to_queue' : '添加文件到上传队列，然后点击启动按钮。',
        'Filename' : '文件名',
        'Status' : '状态',
        'Size' : '大小',
        'Add_Files' : '添加文件',
        'Stop_Upload' : '停止上传',
        'Start_Upload' : '开始上传',
        'Add_files' : '添加文件',
        'Add_files2' : '添加文件。',
        'Stop_current_upload' : '停止当前上传',
        'Start_uploading_queue' : '开始上传队列',
        'Stop_upload' : '停止上传',
        'Start_upload' : '开始上传',
        'Uploaded_files': '已经上传 %d/%d 个文件',
        'N_A' : 'N/A',
        'Drag_files_here' : '拖动文件到这里',
        'File_extension_error': '文件格式不符合要求',
        'File_size_error': '文件大小超过限制',
        'File_count_error': '文件数量错误',
        'Init_error': '初始化错误',
        'HTTP_Error': '网络链接有误',
        'Security_error': '安全错误',
        'Generic_error': '常见错误',
        'IO_error': 'IO错误',
        'File_s': '文件百分比 : %s',
        'Close': '关闭',
        'files_queued': '%d 个队列中',
        'Using_runtime: ': '使用运行时: ',
        'File_size_max_file_size': '文件名: %f, 大小: %s, 文件最大值: %m',
        'Upload_element_accepts': '上传文件只接受%d，其他的文件被忽略',
        'Upload_URL_might': '上传文件有错误或者文件不存在',
        'Error_File_too_large': '文件大小超过限制',
        'Error_Invalid_file_extension': '文件格式不符合要求'
    },

    // 讨论区
    discusstion: {
        'Me':'我',
        'releaseSuccess':'发布成功',
        'touchtoresend':'发布失败',
        "releaseFaildclass": "发布失败班级：",
        "releasefinish": "发布完成",
        "sendsuc": "已成功发送{succount}/{total}个班级",
        "comment": "评论",
        "digg": "赞",
        "commentplaceholder": "写评论…",
        "send": "发送",
        "reply": "回复",
        "edit": "编辑",
        "delete": "删除",
        "from": "来自 {name}的课件",
        "delconfirm": "确定要删除吗？",
        "expand": "展开全部",
        'unexpand':'收起',
        "replyallcount": "查看共{count}条回复",
        "loadmore": "加载更多",
        "commentsuccess": "评论成功",
        "replysuccess": "回复成功",
        "replycomment": "回复评论…",
        "backtopic": "查看主贴",
        "youropinion": "发表你的观点",
        "viewimage": "查看图片",
        "imagelimit": "图片不能超过{count}张",

        //列表页和编辑页
        "loaddata": "数据加载中...",
        "publishtime": "发布于",
        "empty_tip": "讨论区空空的",
        "empty_tip2": "做第一个发帖的人吧~",
        "discussion": "课程讨论",
        "new_idea": "写下这一刻的想法...",
        "publishbtn": "发表",
        "new_discussion": "发起讨论",
        "pic_max": "图片不能超过九张",
        "waitloading": "等待图片上传",
        "deletedtip": "删除后该评论的回复和赞将一并被删除",
        "onlypic": "[图片]",
        'loading': '加载中...',
        end:'没有更多了'
    },

    //新教学日志学习日志
    newlogs: {
        "top":'置顶',
        "transcript": "成绩单",
        "student": "成员管理",
        "discussion": "讨论区",
        "task": "任务",
        "setting": "设置",
        "xiti": "习题集",
        "classmate": "成员",
        "teachinglog": "教学日志",
        "learinglog": "学习日志",
        "publish": "发布",
        "all": "全部",
        "lesson": "课堂",
        "slide": "课件",
        "quiz": "试卷",
        "notice": "公告",
        "loading": "加载中...",
        "clicktopublish_t": "点击右上方发布按钮发布教学活动",
        "clicktopublish_s": "老师还没有发布教学活动",
        "clicktopublish_exp": "目前没有已发布的实验",
        "publishslide": "发布课件",
        "publishquiz": "发布试卷",
        "publishnotice": "发布公告",
        "term": "学期：2017-2018学年度春季学期（第二学期）",
        "onlessontip": "你有{length}个课正在上课",
        "appointment": "预约",
        "appointmenttip": "您有{length}个预约发布",
        'topAnnouncement':'你有{length}条置顶公告',
        'unreadByTopNotice': '其中{length}条未读',
        "unread": "未读",
        "courseedittitle": "编辑标题",
        "delete": "删除",
        "week": "星期",
        "month": "月",
        "day": "日",
        "onlesson": "正在上课",
        "publishaftermin": "约{minute}分钟后发布",
        "publishafterhour": "约{hour}小时后发布",
        "publishafterday": "约{day}小时后发布",
        "publishafterhour": "发送失败",
        "experiment": "实验",
        "entertitle": "输入新的标题~",
        "conotedit": "协同教师无法编辑标题",
        "conotdel": "协同教师无法删除此教学活动",
        "coursedelpubish": "删除后，该教学活动所有数据都将被删除且不可恢复",
        "confirmdelete": "确认删除该教学活动吗？",
        "exp": "实验",
        "syllabus": "课简介",
        "group": "分组",
        "livereplay": "直播回放",
        "exam": "考试",
        "video": "视频",
        "audio": "音频",
        "discuss": "讨论",
        "article": "图文",
        "homework": "作业",
        "online": "线上学习",
        "live": "直播",
        "notallowededit": "暂不支持修改考试标题~",
        "studydeadline": "请在「{deadline}」前完成学习",
        'integrityagreement': "诚信协议",
        "learnagreenment": '学习承诺书',
        "agreen": '同意',
        'cancel': '取消',
        "logs_start_time": "开课时间：",
        "logs_end_time": "无结课时间",
        "logs_to": "至",
    },
    //协同教师管理
    manage_coteacher: {
        "sendletter_tip": "可点击头像查看个人资料并发送私信",
        "promotebtn": "提拔",
        "invitebtn": "邀请",
        "managemenu": "管理",
        "addstudent": "邀请学生",
        "studentlimit": "(若班级人数已达系统上限{count}人，则学生无法加入班级)",
        "delstudent": "删除学生",
        "addcoteacher": "提拔协同教师",
        "delcoteacher": "移除协同教师",
        "delcoteacher1": "取消协同教师",
        "delcoteachertip": "协同教师被移除后，将恢复为学生身份",
        "coteachertit": "协同教师说明",
        "coteacherintor1": "1、协同教师是教师身份，可发布教学任务和授课，同时可添加或删除班级中学生。",
        "coteacherintor2": "2、协同教师可以以学生身份进入到课堂中，但无法作答课堂习题和试卷。",
        "coteacherintor3": "3、协同教师不能提拔新的协同教师，也无法在课程下创建新的班级，只可删除自己发起的教学活动。",
        "nocoteacher": "您当前未添加协同教师",
        "noStudent": "您当前未添加学生",
        "cancel_check": "取消选中",
        "confirmdelete": "确认删除该教学活动吗？",
        "exp": "实验"
    },
    setcourse: {
        "liveStatus0":'未开通',
        "liveStatus1":'审核中',
        "liveStatus2":'申请失败',
        "liveStatus3":'已开通',
        "livePermission":'直播权限',
        "fullname": "课程全称",
        "shortname": "课程简称",
        "optional": "选填",
        "shortname_tip": "课程全称过长，建议填写简称，将在必要的地方显示。",
        "coursetype": "课程类型",
        "required": "必填",
        "k12": "中小学",
        "university": "高校",
        "other": "其他",
        "next": "下一步",
        "shortname_placeholder": "请输入简称 最多6个字",
        "full_tip": "全称",
        "edit": "编辑",
        "classname": "班级名称",
        "semester": "开学学期",
        "join_limit": "加入限制",
        "limit_tip1": "开启后学生将不能通过扫码或暗号加入此班级",
        "limit_tip2": "您可以在教学日志页，通过设置，更改此限制",
        "complete": "完成",
        "editable": "可编辑",
        "pro_coursetip": "专业版课程不可修改课程全称和课程类型",

        "noset": "未设置",
        "k12": "中小学",
        "university": "高校",
        "others": "其他",
        "semester1": "第一学期",
        "semester2": "第二学期",
        "spring": "春",
        "summer": "夏",
        "fall": "秋",
        "winter": "冬",
        "pre":'上一步',
        "courseInfo":'设置开课学期前需先设置开课类型',
        "fallterm": "{year}学年度秋季学期",
        "springterm": "{year}学年度春季学期",
        "summerterm": "{year}学年度夏季学期",
        "clickhere": "点击此处",
        "viptips": "申请会员，审核通过后所有班级都拥有音频和视频直播权限。",
        "studentlimits": "班级人数已达上限{count}人，开启加入限制",
        "limitstoast": "班级人数已达上限{count}人无法关闭限制",
        "classfeatures": "班级开放功能",
        "unavailablefeatures": "学生端将不展示已被关闭的功能",
        "notopenfforum": "学校统一关闭了讨论区，您暂时无法开启",
        "notopenall": "班级人数已达上限，您无法开启功能",
        "allnotjoin": "都不能加入",
        "nojoinafterend": "课堂结束后不能加入",
        "outsidetheschoolcannotjoin": "校外人员不能加入",
        "unselectedstudentsjoinautomatic": "未选课学生加入自动选课",
        "studentsnotsupportedtoselect": "不支持学生自主选课",

        "studyunitlimit": "学习单元查看限制",
        "canstudyafterclass": "结课后学习单元支持学生查看",
        "cannotstudyafterclass": "结课后学习单元不支持学生查看",
    },
    letter: {
        "role": "身份",
        "school": "院校",
        "studentid": "学号",
        "organ": "组织机构",
        "email": "邮箱",
        "chat": "私信戳ta",
        "saysomething": "说点什么~",
        "bindingtip": "仅可对已绑定用户发送私信"
    },
    // 互评
    grading: {
        "scoreofpeergrading": "互评分数占比",
        "scoreofteachergrading": "教师分数占比",
        "pointsofgrading": "评分要点",
        "textareaplaceholder": "请输入您的参考答案或评分要点，供学生参考",
        "hupingguize": "互评规则",
        "rule1": "<i>＊</i>已提交答案的各组才能参加互评，每个组将收到<span class='f15'>一份</span>非本组的作答内容",
        "rule2": "各组之间相互匿名",
        "rule3": "教师可随时修改互评占比或者直接修改总得分",
        "faqihuping": "发起互评",
        "cancel": "取消",
        "save": "保存",
        "launchedgrading" : "Hi，老师发起了互评",
        "pointsgrading" : "评分要点",
        "grade" : "打分",
        "answer" : "答案",
        "gradingscore" : "互评得分：{score}分",
        "gradingtotalscore" : "请输入互评分数（满分{score}分）",
        "notice" : "注意",
        "noticecontent" : "本题以小组形式批改，每人只有一次评分机会<br>成绩以最后一次提交为主",
        "close" : "关闭",
        "gradedalready" : "已有人批改",
        "gradedoverwrite" : "提交后将会覆盖之前的评分",
        "pleasescore" : "请打分",
        "updateOK":"修改成功",
    },
    // 开放平台
    platform: {
        "moretoweb": "更多批改请使用雨课堂网页版",
        "mustpoint": "必填 本题{count}分",
    },
    // 手机号绑定
    bindmobile: {
        "bindPhone": "绑定手机",
        "lawtips": "根据法律要求，互联网账号需实名认证，为保障您的账户安全及正常使用，请完成手机号绑定。",
        "extractminiprogram": "长按识别小程序码绑定手机",
        "closewindow": "绑定完成后，请关闭此窗口"
    },
    //身份认证
    identifyAudit:{
        'infoMsg':'请您如实准确完成身份认证，否则将会驳回',
        'realName':'真实姓名',
        'placeholder1':'请输入您的真实姓名',
        'placeholder2':'绑定手机号',
        'placeholder3':'未验证',
        "hasBind":"已绑定",
        'phoneNumber':'手机号',
        'idCard':'上传您的二代身份证照片',
        'workCard':'上传您的工作证',
        'idCardDetail':'点击上传图标后请仔细阅读温馨提示后按要求上传照片',
        'emailDetail':'如果您是高校教师，建议填写学校邮箱并进行邮箱验证，会加速您的身份认证哦~',
        'email':'学校邮箱验证(选填)',
        'btn':'提交',
        'clickExplain1':"点击拍摄/上传人像面",
        'clickExplain2':"点击拍摄/上传国徽面",
        'clickExplain3':"点击拍摄/上传工作证",
        'identifyAudit':'身份认证',
        'warmInfo':"温馨提示",
        'warmInfoDetail':"请参考下图按照正确的方式上传身份证件，图片大小不大于10MB，确保仅采集身份证本身的信息。",
        'uploadImage':"上传照片",
        "requestError": "请求失败，请刷新后重试",
        'backhomepage': '回到课程首页'
    },
    mystore: {
        'tsinghuabindtitle': '欢迎使用「荷塘·雨课堂」',
        'tsinghuacontent': '使用须完成清华大学身份验证',
        'bind': '身份绑定',
    },
    //直播审核
    liveAudit:{
        "liveApply":'直播申请',
        'rowLabel1':'姓名',
        'rowLabel2':'课程',
        'rowLabel3':'班级',
        'applyReason':'申请理由:',
        'btn1':'提交申请',
        'btn2':'返回',
        'fail':'失败',
        'success':'提交成功',
        'info':'审核将在自提交之日起，7个工作日内完成',
        'tip2':'您的实名认证已成功提交，我们将会在7个工作日内对您提交的信息进行审核，届时您将在微信公众号中收到审核通知，感谢您的使用！',
        'placeholder1':'请您详细描述申请理由，包括但不限于：直播面向的用户、直播内容、预计直播的次数等。',
        'tip':'特别说明：用户使用直播服务必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，对于用户违法或违反直播初衷的使用(包括但不限于言论发表、传送等)而引起的一切责任，由用户负全部责任。',
        'viptips': '特别说明：根据国家工信部对于网络直播实名制的规定，用户申请直播（会员功能）时，需提供手机号、本人身份证等身份关联认证信息，以确保对用户进行真实身份核验。您提供的个人信息将受到严格保护，仅用于身份验证，未经本人许可不会用于其他用途。'
    },

    // 给学生增加备注需求增加
    behavior:{
        "bonuspoint": "课堂加分",
        "addpoints": "+{count}分",
        "howtoaddpoints": "如何加分？",
        "backtoclass": "继续上课",
        "remarks": "加备注",
        "entername": "输入学生姓名",
        "points": "分",
        "changethestate1": "修改为已出勤",
        "changethestate2": "修改为未出勤",
        "nobonuspoint": "暂无加分",
        "tag": "标签",
        "save": "保存",
        "edittag": "编辑标签",
        "addtag": "添加标签",
        "afterclasstips": "此备注课下可在课后小结中查看",
        "entercontent": "请输入标签内容",
        "noquizzes": "本节课没有发布习题",
        "noeligiblestudents": "没有符合的学生",
        "performance": "课堂表现",
        "present": "已出勤",
        "absent": "未出勤",
        "yiqiandao": "已签到",
        "weiqiandao": "未签到",
        "changetosignin": "修改为已签到",
        "changetonotsignin": "修改为未签到",
        "bonus": "加分",
        "pleaseenterinteger": "请输入整数",
        "systemtag": "系统标签不可编辑",
        "tagexists": "已存在相同标签",
        "edit": "编辑",
        "other": "其他",
        "qr": "扫二维码",
        "classcode": "课堂暗号",
        "share": "转发分享",
        "manualmark": "教师手动修改",
        "classtip": "“正在上课”提示",
    },

    // 会员审核
    vipAudit: {
        "applyReason": "申请理由:",
        "placeholder1": "请输入申请理由，包含但不限于：您想体验的功能、使用场景、具体用途…",
        "vipApply": "会员申请",
        "experienceinadvance": "会员功能抢先看",
        "boardonPC": "课堂板书:",
        "insertaudio": "课件插入慕课视频:",
        "livebroadcastinclass": "音视频直播:",
        "morefeaturescomingsoon": "更多功能敬请期待…",
        "distinguishedmembers": "恭喜您已成为雨课堂会员",
        "periodofvalidity": "会员有效期",
        "advance1": "课上随时启用，学生端课上实时观看，课后还能回放过程，配合触控笔和直播效果更佳。",
        "advance2": "制作课件时，可直接插入慕课视频，无需其它视频网站中转，使用更方便。",
        "advance3": "教师可在课堂中开启音视频直播，远程上课的同学同样可以看到课堂，深度参与。",
        'btn1':'提交申请',
        'btn2':'返回',
        'fail':'失败',
        'success':'提交成功',
        'info':'您的申请已提交，我们将尽快为您审核信息',
        'tip2':'您的会员申请已成功提交，由于疫情期间申请人数太多，我们将尽快对您的信息进行审核，届时您将在微信公众号中收到审核通知，感谢您的使用！',
        'interactiveinclass': '互动直播：',
        'invigilatingexam': '在线监考：',
        'downloadpapers': '试卷PDF存档',
        "advance4": "零延时互动直播。老师可共享电脑屏幕，学生可开启麦克风和摄像头与老师互动。",
        "advance5": "覆盖考试前中后全过程。通过行为检测+智能分析，为线考试提供远程监考服务。",
        "advance6": "考试结束后，可以下载学生试卷。每场考试一个文件夹，查找更方便，存档更安心。",
        "chujihuiyuan": "恭喜您已成为雨课堂初级会员",
        "zhongjihuiyuan": "恭喜您已成为雨课堂中级会员",
        "gaojihuiyuan": "恭喜您已成为雨课堂高级会员",
        "chaojihuiyuan": "恭喜您已成为雨课堂超级会员",
        "cloudsave": "云盘存储",
        "advance7": "支持音视频、文档等多类型文件的云端存储。云盘内容与教学过程互通，使用更方便。"
    },

    bindschool: {
        "addschool": "增加学校",
        "shenfenbang": "进行身份绑定",
        "bindtipsshow": `<div class="pt10">绑定后可以同步校内工号/学号、课程数据</div><div>如需开通，请由本校教务电话联系400-689-1199</div>`,
        "binded": "已绑定",
        "weiguixiao": "未和贵校教务系统对接，暂不支持身份绑定",
        "search": "搜索",
        "xuehao": "学号",
        "gonghao": "工号",
        "yuanxi": "院系",
        "sureunbind": "确认解绑{name}?",
        "unbindinacc": "解绑账号",
        "canceunbinding": "取消解绑",
        "jiechuchenggong": "解除账号成功",
        "qxiaoyouhui": "清华校友总会",
        "pleasepc": "请在PC端访问",
        "qufendaxiao": "区分大小写",
        "beishistep": "步骤一：<br/>请先在“北师大企业号”内进行身份验证，<br/>如已验证可跳过此步骤。",
        "beishiqr": `长按识别二维码可进入北师大企业号`,
        "bindstep": "步骤二：<br/>请点击进行雨课堂身份绑定。",
        "bindid": "身份绑定",
        "weibindtips": "您还未绑定学校账号，请先绑定",
        "phonenum": "手机号认证",
        "zmindenti": "账密认证",
        "identi": "身份",
        "plid": "请选择身份",
        "account": "账号",
        "password": "密码",
        "verificode": "验证码",
        "tipscode": "提示：请输入右边显示的验证码",
        "plenterphone": "提示：请输入右边显示的验证码",
        "tips": "提示",
        "xiaoneitips": "此处只支持校内账号登录，自主注册账号请前往账号登录进行验证登录",
        "confirmbind": "确认绑定",
        "cancelbind": "取消绑定",
        "verisuc": "验证成功",
        "numhouback": "{num}秒后自动返回",
        "cmycourse": "查看我的课程",
        "yiaccount": "账号异常",
        "renzheng1": `1、您已通过身份认证，但在“{name}-雨课堂”系统中没有查询到您的账号信息，系统为您自动创建了<span class="color63">学生身份</span>的校内账号；`,
        "renzheng2": "2、系统自动创建的校内账号，默认学号为您认证使用的账号，姓名为您的微信昵称，入学年份默认为学号前四位；",
        "renzheng3": `3、此类账号无法关联校内数据，如您现在加入校内课程，将以<span class="color63">旁听生身份</span>听课，听课数据会被记录；`,
        "xuyaoacteacher": "如有需要，请联系学校教务老师更新人员信息。",
        "gotit": "我知道了",
        "bindfaied": "绑定失败",
        "rebind": "重新绑定",
        "getcode": "获取验证码",
        "num6last": "手机号后6位",
        "guoguan": "国际关系学院",
        "inputpass1": "请输入用于登录校内教务系统的密码",
        "numberwrong": "手机号错误",
        "resend": "重新发送",
        "idnoempty": "学号不能为空",
        "passnoempty": "密码不能为空",
        "selcode": "请录入验证码",
        "verifying": "认证中…",
        "wrongcode": "验证码错误",
        "reginfo": "报名信息",
        "gotobind": "前往绑定",
        "plphonenum": "请输入手机号",
        "backreg": "返回注册页面",
        "yibangdingzhanghao": `您已绑定 <span class="color3 font-weight-600">{name}</span>校内帐号，<br/> 如需修改，请先解绑帐号。`,
        "gaixuexiaobushuzai": "该学校部署在“{enName}”服务器，请前往{name}公众号完成身份认证。首次访问需关注公众号。",
        "changanshibie": "长按识别，二维码有效期截至{expire}",
        "qiehuanservertips": "切换服务器会重新登录确定切换吗？",
        "gaixuexiaobushuzaichongxindenglu": "该学校部署在“{enName}”服务器，需切换至“{name}”服务器重新登录。",
        "qiehuan": "切换服务器",
        "emailverify": "邮箱认证",
        "informationnotfill": "信息未全部填写",
        "emailformatwrong": "邮箱格式错误",
    },


    // 新版首页同步过来的组件
    mobile: {
        // account-logout.vue
        "viewdetail": "查看详情",
        "logouttips": `账号【{userid}】正在注销确认中，预计生效时间：{date}。`,
        "accountcancellationinprogress": "账号注销中",
        "userID": "注销账号：",
        "expectedeffectivetime": "预计注销生效时间：",
        "unrecoverableafterlogout": "完成注销后不可恢复",
        "cancellogoutsuccess": "取消注销成功",
        "cancellogout": "取消注销",
    }
};

if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['exports'], function() {
        return pages;
    });
} else if (typeof exports === 'object' && typeof module === 'object') {
    module.exports = exports = pages; // CommonJS
}

export default pages;



// WEBPACK FOOTER //
// ./src/language/zh_CN.js